module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _c('em', [_vm._v("The Island Division")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The pedigrees in the Laing MS record the ancestry of six Beatons who all descend from a common ancestor Fergus Fionn. They were written by Christopher Beaton, as he himself tells us, and he goes on to record that the owner of the manuscript was Fergus Beaton of Pennycross in Mull. The latter was head of his family from 1657 until not later than 1674, and his pedigree comes fourth in the list."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn29",
      "id": "rfn29"
    }
  }, [_c('sup', [_vm._v("29")])]), _vm._v(" The remaining five pedigrees trace the ancestry of contemporary heads of other Beaton families. Since another Fergus of pedigree II was not head of his family by 4 October 1660, and since Malcolm of pedigree V had probably died by 1670, it can be assumed that the pedigrees were written by Christopher sometime during the decade 1660 to 1670."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn30",
      "id": "rfn30"
    }
  }, [_c('sup', [_vm._v("30")])]), _vm._v(" The number of generations up to and inclusive of Fergus Fionn in each pedigree is 7, 7, 10, 6, 7, and 6 respectively. Taking seven as the average and given the normal thirty years to a generation, Fergus Fionn’s floruit belongs to the second half of the fifteenth century and this is borne out by the dates recorded for his immediate descendants including his eldest son, Gille-Críost, who is on record in 1506."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn31",
      "id": "rfn31"
    }
  }, [_c('sup', [_vm._v("31")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The first pedigree goes on beyond Fergus Fionn to give seven generations of his ancestors beginning with his father, Gille-Críost Mór, son of Gille-Críost Óg, son of Eoin, son of Fíngin, son of Sleimhne, son of Aodh, son of Aibhne Ruadh Mac Bheathadh. Independent evidence for some of the steps in Fergus Fionn’s pedigree comes from Seumas or James Beaton, yet another descendant of Fergus Fionn, who wrote down his own pedigree in the year 1588, claiming that Fergus Fionn was a son of Gille-Críost, son of Sleimhne, son of Aodh."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn32",
      "id": "rfn32"
    }
  }, [_c('sup', [_vm._v("32")])]), _vm._v(" His uncertainty as to his ancestry beyond Fergus Fionn is indicated by the fact that, having changed his mind and deleted "), _c('em', [_vm._v("Aodha")]), _vm._v(", he gave up, simply adding his surname, ."), _c('em', [_vm._v("i")]), _vm._v(". "), _c('em', [_vm._v("Mhaeigbheth.")]), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn33",
      "id": "rfn33"
    }
  }, [_c('sup', [_vm._v("33")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _vm._v("That "), _c('em', [_vm._v("MacBheathadh")]), _vm._v(" of the previous pedigree is also intended to be a surname and not another generation of Fergus Fionn’s ancestors is indicated by the words with which Christopher immediately followed it: “o cantur sliocht an leath ruaghe”, ‘from whom is named the race of the "), _c('em', [_vm._v("leath ruadh")]), _vm._v("’. "), _c('em', [_vm._v("Leath")]), _vm._v(", which means ‘side’ or ‘half’, is almost certainly an error for "), _c('em', [_vm._v("leagha")]), _vm._v(","), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn34",
      "id": "rfn34"
    }
  }, [_c('sup', [_vm._v("34")])]), _vm._v(" genitive of "), _c('em', [_vm._v("líaigh")]), _vm._v(", ‘physician’, and therefore ‘the red-haired physician’ must refer to Aibhne Ruadh MacBeth, the final step of the pedigree. Sometime in the first half of the sixteenth century a compendium of medical definitions in Latin and Gaelic was written into MS IV belonging to Neill Óg Beaton by "), _c('em', [_vm._v("Mael-Sheachlainn mac Iollainn mhic an Leagha Ruaidh")]), _vm._v(", ‘Mael-Seachlainn, son of Iollann, son of the Red-haired Physician’."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn35",
      "id": "rfn35"
    }
  }, [_c('sup', [_vm._v("35")])]), _vm._v(" Other members of this family who used "), _c('em', [_vm._v("Mac an leagha")]), _vm._v(", Anglicised "), _c('em', [_vm._v("MacLeay")]), _vm._v(", as a surname can be identified in late fifteenth and sixteenth century Ireland."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn36",
      "id": "rfn36"
    }
  }, [_c('sup', [_vm._v("36")])]), _vm._v(" The forename "), _c('em', [_vm._v("Iollann")]), _vm._v(" is very uncommon and it is significant therefore that a "), _c('em', [_vm._v("Iollann Maigbhetha")]), _vm._v(" was present at the writing of MS CXVII, another Gaelic medical manuscript of Scottish provenance at Aghamacart in Upper Ossory in 1596."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn37",
      "id": "rfn37"
    }
  }, [_c('sup', [_vm._v("37")])]), _vm._v(" The writer of most of it and eventual owner was Donnchadh Ó Conchobhair, employed as physician to the MacDougalls of Dunollie. Christopher then was indicating that, besides being "), _c('em', [_vm._v("Clann Mheic-bheathadh")]), _vm._v(", the Beatons could also be described as "), _c('em', [_vm._v("Sliocht an Leagha Ruaidh")]), _vm._v(" after Aibhne Ruadh. It is clear also that not all of the kindred came to Scotland c.1300 and that those who remained in Ireland continued to practise medicine but normally preferred the surname derived from their professional kindred name. As already pointed out they never adopted the surname "), _c('em', [_vm._v("Beaton")]), _vm._v(" for use in non-Gaelic contexts. According to the number of generations in the pedigree, Aibhne, "), _c('em', [_vm._v("an Líaigh Ruadh")]), _vm._v(", flourished in the first half of the thirteenth century indicating that the kindred was already pursuing medicine as a profession.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Nor did Christopher neglect to record the genealogical antecedents of his earlier and eponymous ancestor, Mac-bethad. The section following the fifth pedigree is headed "), _c('em', [_vm._v("Gionolach chloinn meic-bheathadh")]), _vm._v(", ‘The Pedigree of the Kindred of Mac-bethad’, who, Christopher tells us, was "), _c('em', [_vm._v("ó,")]), _vm._v(" ‘grandson or descendant’, of Cú-bethad, eleven generations of whose ancestors are then named back to Niall Noígiallach, the eponymous ancestor of the Uí Néill, the most important people in Ireland for much of "), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _vm._v("the Dark Ages."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn38",
      "id": "rfn38"
    }
  }, [_c('sup', [_vm._v("38")])]), _vm._v(" Niall is supposed to have flourished c.400 which in purely genealogical terms locates Mac-bethad in the ninth century, but only if "), _c('em', [_vm._v("ó")]), _vm._v(" has the more precise meaning of grandson in this instance. But even so no reliance should be placed on this date, for his genealogy is wholly spurious. One or two of the names may even have been manufactured on the spot for the purpose, others were taken more or less at random from a pedigree entitled "), _c('em', [_vm._v("Genelach Ceneoil Binnich Tilcha Óc")]), _vm._v(" which appears in the great compendium of genealogical material contained in Rawlinson B 502 and the Books of Ballymote and Lecan."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn39",
      "id": "rfn39"
    }
  }, [_c('sup', [_vm._v("39")])]), _vm._v(" This is the only occurrence of the name "), _c('em', [_vm._v("Cú-bethad")]), _vm._v(" in the whole collection and it is easy to see how its similarity to "), _c('em', [_vm._v("Mac-bethad")]), _vm._v(", plus the presence in the same pedigree of Niall Noígiallach, that most desirable of ancestors, prompted the genealogist to make use of the pedigree in his construction of one for Mac-bethad."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn40",
      "id": "rfn40"
    }
  }, [_c('sup', [_vm._v("40")])]), _vm._v(" Cú-bethad is the fourth step therein, while Daithcheall mac Conghallainn, father and grandfather of Cú-bethad in the Laing MS are steps 9 and 10 in the Irish pedigree. Eochu Binnech mac Eoghain mheic Néill Noígiallaigh, steps 18, 19 and 20 of the Irish pedigree, do duty as the final steps of Mac-bethad’s pedigree. The end result is that Cú-bethad is genealogically placed in the eighth century by one pedigree and in the tenth century by the other.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There is no need to suppose that Christopher was himself responsible for concocting Mac-bethad’s ancestry. The substitution of "), _c('em', [_vm._v("leath")]), _vm._v(" for "), _c('em', [_vm._v("leagha")]), _vm._v(" looks like a copyist’s error rather than one made from memory. The implication is that Christopher had in his possession a manuscript which already contained the names of Fergus Fionn’s ancestors, possibly including the error, and therefore probably also Mac-bethad’s alleged pedigree.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The recital of Mac-bethad’s ancestors was a natural conclusion to Christopher’s genealogical scheme, suggesting that pedigree VI which follows was something of an afterthought. Indeed, he may even have regretted writing it down for, turning to Latin and secretary script, he concluded:")]), _vm._v(" "), _c('div', {
    staticClass: "move"
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("“De his rebus satis dictum et scriptum per me.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("‘Enough has been said and written regarding these matters by me.’")])]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _vm._v("It is a matter of regret that he did not continue. But perhaps more significantly, Christopher added a clause to the end of pedigree V which presumably applied to all the Beatons mentioned previously and should have applied equally to those of pedigree VI had it formed part of his original scheme. It reads “dar goradh an tuath mór”, ‘who are known as the great people’,"), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn41",
      "id": "rfn41"
    }
  }, [_c('sup', [_vm._v("41")])]), _vm._v(" presumably in recognition of their present ubiquity and/or their reputation acquired over the centuries.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("By the time the Irish branch of the kindred comes to light again in the late medieval period, they were located chiefly in Co. Sligo,"), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn42",
      "id": "rfn42"
    }
  }, [_c('sup', [_vm._v("42")])]), _vm._v(" but both Christopher and James Beaton state that their ancestors came originally from "), _c('em', [_vm._v("Achadh Dubhthaigh")]), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn43",
      "id": "rfn43"
    }
  }, [_c('sup', [_vm._v("43")])]), _vm._v(" or Achadowey which lies to the south of Coleraine in Co. Derry. Christopher adds that Achadowey was “in airacht i Cathain”, ‘in the territory of Uí Cathain’."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn44",
      "id": "rfn44"
    }
  }, [_c('sup', [_vm._v("44")])]), _vm._v(" Seventeenth century historians maintain that a daughter of Cú-maige nan Gall Ó Catháin of Keenaght married Angus Óg, Lord of the Isles, probably sometime towards the end of the thirteenth century."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn45",
      "id": "rfn45"
    }
  }, [_c('sup', [_vm._v("45")])]), _vm._v(" In one account her name is given as Áine."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn46",
      "id": "rfn46"
    }
  }, [_c('sup', [_vm._v("46")])]), _vm._v(" Contemporary confirmation of the name and of this tradition is to be found in an English safe conduct of 1338 allowing Agnes, mother of John, Lord of the Isles, to travel between Scotland and Ireland at will."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn47",
      "id": "rfn47"
    }
  }, [_c('sup', [_vm._v("47")])]), _vm._v(" Perhaps the most persistent feature of the traditional account is that Áine came to Scotland with a wedding retinue or bodyguard of men ("), _c('em', [_vm._v("léine chneas")]), _vm._v(") who proceeded to settle there."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn48",
      "id": "rfn48"
    }
  }, [_c('sup', [_vm._v("48")])]), _vm._v(" This was the custom of the time,"), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn49",
      "id": "rfn49"
    }
  }, [_c('sup', [_vm._v("49")])]), _vm._v(" but the singular thing about Áine’s retinue seems to have been its size and the number of Scottish families or clans whose progenitors are said to have formed part of it. The ‘History of the MacDonalds’ claims that it consisted of “seven score men out of every surname under O’Kain”. "), _c('em', [_vm._v("Beaton")]), _vm._v(", standing for "), _c('em', [_vm._v("MacBeth")]), _vm._v(", is among the surnames that are listed "), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _vm._v("separately."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn50",
      "id": "rfn50"
    }
  }, [_c('sup', [_vm._v("50")])]), _vm._v(" Finally, the earliest Beaton doctor on record in Scotland is more or less contemporary, namely, Patrick "), _c('em', [_vm._v("MacBeth")]), _vm._v(", ‘principal physician’ to Robert I"), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn51",
      "id": "rfn51"
    }
  }, [_c('sup', [_vm._v("51")])]), _vm._v(" and probably progenitor of the mainland division of the Beaton medical kindred. Nor is it surprising to find a Beaton in Robert Bruce’s service in view of the latter’s close association with the west of Scotland and with the Clan Donald and their leader Angus Óg in particular."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn52",
      "id": "rfn52"
    }
  }, [_c('sup', [_vm._v("52")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The centre of MacDonald power at this time was Islay and traditionally the Beatons settled in the parish of Kilchoman. Their presence there at least by the second half of the fourteenth century is confirmed by the erection in the churchyard of a fine cross in the West Highland style commemorating Beatons, apparently of the mainland division."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn53",
      "id": "rfn53"
    }
  }, [_c('sup', [_vm._v("53")])]), _vm._v(" The first certain Beaton on record in Islay is Fergus who signed and probably wrote in the Gaelic language and script a charter recording a grant of lands in Islay by Donald, Lord of the Isles, in 1408."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn54",
      "id": "rfn54"
    }
  }, [_c('sup', [_vm._v("54")])]), _vm._v(" It has been suggested that he should be identified with Fergus Fionn of the pedigrees,"), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn55",
      "id": "rfn55"
    }
  }, [_c('sup', [_vm._v("55")])]), _vm._v(" but for this Fergus, presumably an adult in 1408, to have had a grandson still alive in the 1570s, is, while not impossible, unlikely and he is more likely to have been an earlier collateral kinsman of Fergus Fionn."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn56",
      "id": "rfn56"
    }
  }, [_c('sup', [_vm._v("56")])]), _vm._v(" Another possible early Beaton and kinsman of Fergus Fionn, who was archdeacon of the Isles from 1408 until his death c.1441, was "), _c('em', [_vm._v("Cristine Donaldi y leich")]), _vm._v(", Cristinus, ‘son of Donald the physician’."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn57",
      "id": "rfn57"
    }
  }, [_c('sup', [_vm._v("57")])]), _vm._v(" "), _c('em', [_vm._v("Cristinus")]), _vm._v(" is the normal Latin equivalent for Gaelic "), _c('em', [_vm._v("Gille-Críost")]), _vm._v(", a common Beaton forename at an early stage."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn58",
      "id": "rfn58"
    }
  }, [_c('sup', [_vm._v("58")])]), _vm._v(" Another Beaton churchman, who had connections with Islay, was Sir Christopher "), _c('em', [_vm._v("Makwia")]), _vm._v(" or "), _c('em', [_vm._v("Makvia. Christopher")]), _vm._v(" is an alternative but less common Latin equivalent "), _c('em', [_vm._v("of Gille-Críost")]), _vm._v(". Dead by May 1535, he had been chaplain "), _c('em', [_vm._v("of Ilane Oirsay")]), _vm._v(","), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn59",
      "id": "rfn59"
    }
  }, [_c('sup', [_vm._v("59")])]), _vm._v(" the small island of Orsay off Portnahaven in "), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _vm._v("the parish of Kilchoman. The site of a chapel still appears on the map."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn60",
      "id": "rfn60"
    }
  }, [_c('sup', [_vm._v("60")])]), _vm._v(" That the Beatons in Kilchoman remained the senior branch of the island division of the kindred into the seventeenth century is perhaps sufficiently demonstrated by the 1609 confirmation of lands in Kilchoman by James VI to Fergus MacBeth in his capacity as ‘chief physician within the bounds of the Islands of Scotland’ and whose predecessors, we are told, held these same lands from the Lords of the Isles, ‘beyond all memory of men’."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn61",
      "id": "rfn61"
    }
  }, [_c('sup', [_vm._v("61")])]), _vm._v(" The cross set up at Kilchoman was acknowledgement of their seniority by the mainland division of the kindred, while the Beatons of Husabost traced their ultimate origins to Islay."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn62",
      "id": "rfn62"
    }
  }, [_c('sup', [_vm._v("62")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Fergus Fionn was himself no doubt head of the Islay Beatons in the second half of the fifteenth century. The crown rental of 1506 lists “Gilcristus McVaig, surrigicus” as one of eight crown tenants in Islay."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn63",
      "id": "rfn63"
    }
  }, [_c('sup', [_vm._v("63")])]), _vm._v(" Gille-Críost is the name of the first of Fergus Fionn’s sons to appear in the Laing MS pedigrees, and, since his grandfather was also Gille-Críost, he is likely to be Fergus Fionn’s eldest son. In turn Gille-Críost’s son in these same pedigrees is Fergus and Fergus is the tenant of the lands of Ballenabe and Areset near the church of Kilchoman according to the crown rental of 1541. Therein he is called Fergus "), _c('em', [_vm._v("Oldowe")]), _vm._v(", that is, Fergus "), _c('em', [_vm._v("Ollamh")]), _vm._v(" or Fergus, the physician."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn64",
      "id": "rfn64"
    }
  }, [_c('sup', [_vm._v("64")])]), _vm._v(" We are told further in 1542 that the fermes of Ballenabe were granted to Fergus for his fee as a "), _c('em', [_vm._v("medicus")]), _vm._v("."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn65",
      "id": "rfn65"
    }
  }, [_c('sup', [_vm._v("65")])]), _vm._v(" Finally, Ballenabe and Areset were among the lands confirmed in the possession of the later Fergus in 1609.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Indeed, there seems to be contemporary record of another son and two grandsons of Fergus Fionn named in the Laing MS pedigrees. Donald Mór, son of Fergus Fionn in pedigree IV, may be the same as Donaldus "), _c('em', [_vm._v("Litch")]), _vm._v(", ‘Donald Leich’, who held lands in south Kintyre in 1541."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn66",
      "id": "rfn66"
    }
  }, [_c('sup', [_vm._v("66")])]), _vm._v(" It is certainly his son, Gill-Anndrais, who was granted the lands of Pennycross, Mull, in 1572."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn67",
      "id": "rfn67"
    }
  }, [_c('sup', [_vm._v("67")])]), _vm._v(" Gille-Coluim Cléireach, son of Gill-Anndrais, son of Fergus Fionn, of pedigrees III and V may be the same as Malcolm Leich who held lands in the parish of Kilchoman according to the Islay crown rental of 1541."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn68",
      "id": "rfn68"
    }
  }, [_c('sup', [_vm._v("68")])]), _vm._v(" This might be thought strange in view of the fact that his first cousin Fergus Ollamh held lands in the same parish in virtue of being "), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _vm._v("a physician. But here we may have an example of "), _c('em', [_vm._v("Leich")]), _vm._v(" being used purely as a surname without reference to Gille-Coluim’s profession, for his epithet "), _c('em', [_vm._v("cléireach")]), _vm._v(" suggests that he was not a physician but either a man of letters or in the church."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn69",
      "id": "rfn69"
    }
  }, [_c('sup', [_vm._v("69")])])]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "sec1"
    }
  }), _vm._v("Beatons in Portree")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The only grandson of Fergus Fionn named in the Laing MS who remains unidentified elsewhere is Neill, son of Gill-Anndrais of pedigree VI. However, it seems likely that Fergus Fionn had another grandson named Neill who does not figure in the Laing MS pedigrees. It has already been noted that, in 1588, James Beaton wrote down his pedigree which reads: James, son of Ruairi, son of Neill, son of Gille-Críost, son of Fergus, son of Gille-Críost, son of Fergus Fionn. There is an obvious discrepancy here, for it would be impossible for Fergus Ollamh, son of Gille-Críost, son of Fergus Fionn, who flourished in 1541, to have had a descendant four generations removed who was alive only forty-seven years on and an adult at that. Looked at from the other direction the discrepancy is equally obvious. According to his pedigree, James was the same number of generations or one more removed from Fergus Fionn as five of the six people whose pedigrees appear in the Laing MS, all of whom were alive after 1660. We have to assume that James, having, as already noted, omitted steps in his pedigree beyond Fergus Fionn, added steps before Fergus Fionn."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn70",
      "id": "rfn70"
    }
  }, [_c('sup', [_vm._v("70")])]), _vm._v(" It seems most likely that he inadvertently repeated Gille-Críost, son of Fergus, a common error in this type of genealogy, but made more difficult to detect in this instance because pedigree I in the Laing MS does have legitimate repetition of these two names at this very point."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn71",
      "id": "rfn71"
    }
  }, [_c('sup', [_vm._v("71")])]), _vm._v(" However, it is significant that the epithet "), _c('em', [_vm._v("óg")]), _vm._v(", specifically applied to the first "), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _vm._v("Gille-Críost in pedigree I to distinguish him from his grandfather of the same name, is not present in James’ pedigree. Removing the two unnecessary steps, the latter now reads James, son of Ruairi, son of Neill, son of Gille-Críost, son of Fergus Fionn, which makes Neill, grandfather of James, a brother of Fergus Ollamh and fits James satisfactorily into the overall genealogical pattern.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("James, as he tells us himself, was in Sleat at the time of writing in 1588."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn72",
      "id": "rfn72"
    }
  }, [_c('sup', [_vm._v("72")])]), _vm._v(" It is probable therefore that Neill, son of Ruairi, “leiche, duelling in Portrie” and doubtless employed by the MacDonalds of Sleat, who signed in the Gaelic language and script a discharge in 1610, was a brother of James,"), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn73",
      "id": "rfn73"
    }
  }, [_c('sup', [_vm._v("73")])]), _vm._v(" perhaps an older brother, since their grandfather was also called Neill. James had another brother whom he does not name but whose death in 1588 he records."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn74",
      "id": "rfn74"
    }
  }, [_c('sup', [_vm._v("74")])]), _vm._v(" Presumably none had descendants who survived into 1670, the latest point at which Christopher Beaton could have written the Laing MS genealogies, hence, although descendants of Fergus Fionn, they do not appear therein.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There follows James’ corrected pedigree from Fergus Fionn:")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Illustration",
      "src": "images/f0014-01.png"
    }
  })]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "sec2"
    }
  }), _vm._v("Beatons of Ballenabe")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("James in 1588 declared that he had only recently been in Islay in the company of Fergus, son of John, son of Fergus, the owner of the manuscript in which James recorded this information. Elsewhere in the manuscript we are told that it was written in the year 1563 for John Beaton."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn75",
      "id": "rfn75"
    }
  }, [_c('sup', [_vm._v("75")])]), _vm._v(" In pedigree II of the Laing MS, Fergus Ollamh is given a son, John,"), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn76",
      "id": "rfn76"
    }
  }, [_c('sup', [_vm._v("76")])]), _vm._v(" who no doubt succeeded him in Ballenabe sometime before 1563. In turn presumably, John was succeeded by his son, Fergus. ‘The book of Fergus MacBhethad’ from which Richard Ó Conchobhair completed "), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }), _vm._v("transcribing a medical treatise on 1 April 1590 may well have been another manuscript belonging to Fergus of Ballenabe."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn77",
      "id": "rfn77"
    }
  }, [_c('sup', [_vm._v("77")])]), _vm._v(" It will be seen that the Ó Conchobhairs of Aghamacart in Upper Ossory had close medical ties with Scotland."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn78",
      "id": "rfn78"
    }
  }, [_c('sup', [_vm._v("78")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At this point we leave the Laing MS pedigrees, for Fergus, son of John, is not recorded therein. The next certain Beaton occupant of Ballenabe to be named is the Fergus who was confirmed in his possession of this and other lands in Islay in 1609."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn79",
      "id": "rfn79"
    }
  }, [_c('sup', [_vm._v("79")])]), _vm._v(" In July of 1616 he was taken under the formal protection of the crown:")]), _vm._v(" "), _c('div', {
    staticClass: "move"
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("“Forsamekle as we are crediblie informit that oure lovit Fergus McBeth of Ballanavy hes at all tymes bigane profest our obedience and behavit him sellf as ane dewtifull and obedient subject to us”.")])]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("The assumption must be that Fergus had not supported the insurrection of the MacDonalds of Islay in the previous year and was now in danger from some of their number who were again threatening action in the Isles."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn80",
      "id": "rfn80"
    }
  }, [_c('sup', [_vm._v("80")])]), _vm._v(" Neither source names Fergus’s father and it is known that Fergus was dead by 25 March 1628."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn81",
      "id": "rfn81"
    }
  }, [_c('sup', [_vm._v("81")])]), _vm._v(" Thus, it is tempting to equate him with Fergus, son of John, but a confirmation of lands is often granted when the grantee inherits them and Fergus, son of John, had presumably already succeeded by 1588. Furthermore, a list of converts to Roman Catholicism in Islay dated 1625 includes "), _c('em', [_vm._v("Fergusius Giollendrus")]), _vm._v(" or Fergus, son of Gill-Anndrais, a combination of forenames which makes a Beaton identification almost a certainty."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn82",
      "id": "rfn82"
    }
  }, [_c('sup', [_vm._v("82")])]), _vm._v(" Gill-Anndrais was therefore either a son of Fergus, son of John, or perhaps more likely, in view of the number of generations involved, a brother.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Finally, John "), _c('em', [_vm._v("MacBeth")]), _vm._v(" was retoured heir to his father, Fergus, on 25 March 1628."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn83",
      "id": "rfn83"
    }
  }, [_c('sup', [_vm._v("83")])]), _vm._v(" By an agreement made at Inveraray on 29 September 1629, he turned Ballenabe and the other Beaton lands over to Archibald Campbell, Lord of Lorn,"), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn84",
      "id": "rfn84"
    }
  }, [_c('sup', [_vm._v("84")])]), _vm._v(" and the two instruments of sasine necessary to complete the transaction were issued on 10 October."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn85",
      "id": "rfn85"
    }
  }, [_c('sup', [_vm._v("85")])]), _vm._v(" It is probably John who appears again in the Islay rental for 1643 as "), _c('em', [_vm._v("Jon Beatoun")]), _vm._v(" renting the "), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }), _vm._v("lands of Cultowne in the parish of Kilchoman."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn86",
      "id": "rfn86"
    }
  }, [_c('sup', [_vm._v("86")])]), _vm._v(" Thereafter he drops out of sight and this seems to spell the end of the senior Beaton family in Scotland. It explains why, although the Islay family is, in its later stages, descended from Fergus Fionn, Christopher does not include them in the Laing MS pedigrees. Either John disappeared without a trace or had died, leaving no descendants, before 1670, the latest point at which Christopher could have written his pedigrees.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There follows the pedigree of the Beatons of Ballenabe from Fergus Fionn:")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Illustration",
      "src": "images/f0016-01.png"
    }
  })]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "sec3"
    }
  }), _vm._v("Beatons in North Uist (Pedigree I)")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("As the identification of each individual Laing MS pedigree proceeds, it will become clear that the order in which they were written down was probably not haphazard. Christopher first records the pedigrees of the three surviving Beaton families descended from Fergus Fionn who were employed by the MacDonalds of Sleat in their three main territories of North Uist, Trotternish and Sleat in that order. Only then does he give the pedigree of the Beatons of Pennycross in Mull, his hosts at the time of writing, and the most famous Beaton medical family of the period, since the demise of the Islay branch. The remaining two pedigrees belong respectively to the Beatons employed by the Clan Ranald in South Uist and perhaps the MacKenzies of Seaforth.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Christopher himself does not figure in the Laing MS pedigrees, presumably because his father was still alive and still head of his family. And indeed Christopher must have been a comparatively young man at the time of writing, for he also wrote the greatest part of the manuscript often called the Black Book of Clanranald, now in the National Museum of "), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }), _vm._v("Antiquities of Scotland, in which the latest dateable entry cannot have been made by Christopher earlier than the year 1715."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn87",
      "id": "rfn87"
    }
  }, [_c('sup', [_vm._v("87")])]), _vm._v(" Some of it he copied from the so-called Red Book of Clanranald, also in the National Museum, written mainly by his contemporary Neill MacMhuirich, the well-known poet and "), _c('em', [_vm._v("seanchaidh")]), _vm._v(" to Clan Ranald who died c.1726."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn88",
      "id": "rfn88"
    }
  }, [_c('sup', [_vm._v("88")])]), _vm._v(" On p. 179 of the latter manuscript Christopher corrected an error by Neill. He did not sign his work in the Black Book but his handwriting is easily recognised and he further betrays his identity by including in a genealogical section, otherwise devoted to important territorial kindreds, the second and fictional part of the common Beaton pedigree more or less as it appears in the Laing MS."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn89",
      "id": "rfn89"
    }
  }, [_c('sup', [_vm._v("89")])]), _vm._v(" It is likely that Aodh of pedigree I was Christopher’s father, and it is significant that only in this pedigree does there appear at a late stage the forename "), _c('em', [_vm._v("Gille-Críost")]), _vm._v(" for which "), _c('em', [_vm._v("Christopher")]), _vm._v(" is a Latin equivalent. The authors of "), _c('em', [_vm._v("Clan Donald")]), _vm._v(" wrote:")]), _vm._v(" "), _c('div', {
    staticClass: "move"
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("“In North Uist a branch of this family (Beaton) were hereditary physicians to the MacDonalds for many generations. The last of them, Niel Beaton, died in 1763”."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn90",
      "id": "rfn90"
    }
  }, [_c('sup', [_vm._v("90")])])])]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("There is other evidence besides the order of the first three pedigrees that it was Christopher’s family who were employed by the MacDonalds of Sleat in North Uist, although the content of the Black Book of Clanranald suggests that, latterly at any rate, Christopher himself was tutor to a family of the Clan Donald of Antrim in Northern Ireland. Christopher wrote a medical note partly in Gaelic and partly in Latin into the Laing MS"), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn91",
      "id": "rfn91"
    }
  }, [_c('sup', [_vm._v("91")])]), _vm._v(" but his main interests were the related topics of history, genealogy and chronology, and it may be that his family were primarily historians and genealogists.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Certainly the MacDonalds of Sleat did have a "), _c('em', [_vm._v("seanchaidh")]), _vm._v(" or historian in their ranks about this time, for the ‘History of the MacDonalds’ so called, written in English in the reign of Charles II,"), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn92",
      "id": "rfn92"
    }
  }, [_c('sup', [_vm._v("92")])]), _vm._v(" is biased in their favour."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn93",
      "id": "rfn93"
    }
  }, [_c('sup', [_vm._v("93")])]), _vm._v(" It is no longer complete and survives now only in an unsigned manuscript copy."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn94",
      "id": "rfn94"
    }
  }, [_c('sup', [_vm._v("94")])]), _vm._v(" Its content, although garbled on occasion, partly because of the "), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }), _vm._v("attempt to write a consecutive narrative in translation from what were probably disparate and disjointed Gaelic originals, nevertheless gives the impression of deriving from the shared corpus of historical and genealogical material available to the learned professional orders of Gaelic society. Internal evidence further suggests that the particular professional source from which the material derived was the Beatons. Thus, the author, describing the seating arrangements at a banquet held by Alexander, Lord of the Isles (d. 1449), specifically places “Beatton, the principal physician” above “MacMurrich, the poet” in order of precedence."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn95",
      "id": "rfn95"
    }
  }, [_c('sup', [_vm._v("95")])]), _vm._v(" Moreover, more space is devoted to the surname "), _c('em', [_vm._v("Beaton")]), _vm._v(" than to any other in the list of surnames of those who came over to Scotland in the retinue of Áine Ní Chatháin."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn96",
      "id": "rfn96"
    }
  }, [_c('sup', [_vm._v("96")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("That the specific family of Beatons involved was the one domiciled in North Uist is suggested by two things. First and most obviously the knowledge displayed of local conditions in North Uist is more detailed than for any of the other territories belonging to the Clan Donald of Sleat. Secondly the attitudes of Christopher and the author of the "), _c('em', [_vm._v("History")]), _vm._v(" towards the surname "), _c('em', [_vm._v("Beaton")]), _vm._v(" and the implications of its use are exactly similar. The latter states that the Beatons are:")]), _vm._v(" "), _c('div', {
    staticClass: "move"
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("“so now called but improperly, that being a French name, whereas they are Irish, of the tribe of O’Neals, and took the name first from following the name of Beda”."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn97",
      "id": "rfn97"
    }
  }, [_c('sup', [_vm._v("97")])])])]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("It has already been noted that Christopher located their eponym Macbethad or Mac-betha, that is, “Beda”, in Ireland and traced his ancestry from Niall Noígiallach, the eponym of the Uí Néill or the “O’Neals”."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn98",
      "id": "rfn98"
    }
  }, [_c('sup', [_vm._v("98")])]), _vm._v(" His refusal to use "), _c('em', [_vm._v("Betonus")]), _vm._v(" in a Latin context which, along with "), _c('em', [_vm._v("Beaton")]), _vm._v(" in Scots or English, had become normal practice by the middle of the seventeenth century, is surely significant. He wrote his own surname as "), _c('em', [_vm._v("MacVeagh")]), _vm._v(", a Scoticised version of the Gaelic, as he did the surname of his host, Fergus of Pennycross,"), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn99",
      "id": "rfn99"
    }
  }, [_c('sup', [_vm._v("99")])]), _vm._v(" although Fergus himself never used any other form than "), _c('em', [_vm._v("Beaton")]), _vm._v("."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn100",
      "id": "rfn100"
    }
  }, [_c('sup', [_vm._v("100")])]), _vm._v(" Indeed, one of Christopher’s aims in writing the pedigrees may have been to scotch the false French origins of the Beaton medical kindred. However, he seems not to have convinced the Beatons of Pennycross, for a graveslab commissioned for a member of the family in 1674 has carved on "), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }), _vm._v("it an armorial medallion which includes heraldic devices elsewhere associated with the Fife Beatons."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn101",
      "id": "rfn101"
    }
  }, [_c('sup', [_vm._v("101")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Was the author of the "), _c('em', [_vm._v("History")]), _vm._v(" himself a Beaton? First of all it was not Christopher, for specimens of his English in the Black Book of Clanranald are quite different in style and orthography. However, Christopher’s facility in English may be itself a pointer to a relationship between him and the author of the "), _c('em', [_vm._v("History")]), _vm._v(". It could be argued that the way in which the latter referred to “our Highland shenakies”"), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn102",
      "id": "rfn102"
    }
  }, [_c('sup', [_vm._v("102")])]), _vm._v(" indicates that he did not consider himself to be one and therefore that he was not a member of the professional learned orders. On the other hand as a member of a family whose profession had always in the past at least been medicine, he may have looked upon himself as an amateur in historiography.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Another and, on the face of it, more telling objection to the author of the "), _c('em', [_vm._v("History")]), _vm._v(" being a Beaton is the fact that Donald Gregory in 1836 names him Hugh MacDonald. He may have got this information from the person who gave him access to the manuscript, namely, Sir William MacLeod Bannatyne (1743–1833), a noted antiquarian and Gaelic scholar of his time."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn103",
      "id": "rfn103"
    }
  }, [_c('sup', [_vm._v("103")])]), _vm._v(" However, he or Bannatyne could have deduced the author’s identity from Martin Martin who, writing in 1703 about the battle of Bloody Bay, claimed to be following “the genealogists Macvurich and Hugh Macdonald in their manuscripts”."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn104",
      "id": "rfn104"
    }
  }, [_c('sup', [_vm._v("104")])]), _vm._v(" The accounts of the Lordship of the Isles in ‘The Book of Clanranald’, which is of MacMhuirich authorship, and in the "), _c('em', [_vm._v("History of the MacDonalds")]), _vm._v(" both deal with this battle."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn105",
      "id": "rfn105"
    }
  }, [_c('sup', [_vm._v("105")])]), _vm._v(" But there is evidence from the seventeenth century that a servitor, in whatever capacity, was sometimes given his employer’s surname. Particularly relevant from our point of view is the contemporary MacRae genealogical tract that names Maol-Domhnaich Ó Muirgheasain, poet and "), _c('em', [_vm._v("seanchaidh")]), _vm._v(" to the MacLeans of Duart in the second half of the seventeenth century, as "), _c('em', [_vm._v("Mildonich MacLean")]), _vm._v("."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn106",
      "id": "rfn106"
    }
  }, [_c('sup', [_vm._v("106")])]), _vm._v(" Since "), _c('em', [_vm._v("Hugh")]), _vm._v(" is the normal English equivalent of Gaelic "), _c('em', [_vm._v("Aodh")]), _vm._v(", it is possible that Aodh Beaton and Hugh MacDonald are one and the same person.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }), _c('em', [_vm._v("Aodh")]), _vm._v(" is a very rare Beaton forename. It first appears six generations beyond Fergus Fionn and apparently not again until borne by Christopher’s father. Its resurrection after such a long interval may be further evidence for the antiquarian bent of this particular Beaton family, so clearly demonstrated by Christopher himself. However, medicine continued to hold the interest of some members thereof, for Neill, son of Aodh MacBeathadh, claimed ownership of the medical manuscript written in 1563 which, as already noted, was in the hands of James Beaton in 1588."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn107",
      "id": "rfn107"
    }
  }, [_c('sup', [_vm._v("107")])]), _vm._v(" It eventually came into the possession of the Beatons of Pennycross, the first of whom to sign his name on it was Fergus, Christopher’s host."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn108",
      "id": "rfn108"
    }
  }, [_c('sup', [_vm._v("108")])]), _vm._v(" It is likely that Neill was Christopher’s brother. Indeed the manuscript may have been given to Fergus by Christopher on the occasion of his visit to Pennycross.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Fergus in turn may have given Christopher a Pennycross manuscript, namely, MS XXIX."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn109",
      "id": "rfn109"
    }
  }, [_c('sup', [_vm._v("109")])]), _vm._v(" The last Beaton of Pennycross to write his name on it was John (d. 1657)."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn110",
      "id": "rfn110"
    }
  }, [_c('sup', [_vm._v("110")])]), _vm._v(" Thereafter it seems to have moved in a more northerly ambit. Neill MacMhuirich signed it and later Beatons named therein can be identified as belonging to families employed by Clan Ranald and Clan Donald of Sleat."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn111",
      "id": "rfn111"
    }
  }, [_c('sup', [_vm._v("111")])]), _vm._v(" They include "), _c('em', [_vm._v("Neill McVey")]), _vm._v(" who signed thus and is likely to be Christopher’s above-mentioned brother, using, like Christopher, a Scoticised form of his Gaelic surname in preference to "), _c('em', [_vm._v("Beaton")]), _vm._v(" in a non-Gaelic context."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn112",
      "id": "rfn112"
    }
  }, [_c('sup', [_vm._v("112")])]), _vm._v(" He probably continued to practise medicine in North Uist, and his namesake who died there in 1763 was doubtless of the same family."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn113",
      "id": "rfn113"
    }
  }, [_c('sup', [_vm._v("113")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Christopher may have had a son called Fergus. It has already been pointed out that the content of the Black Book of Clanranald written between 1702 and 1715 implies that, for the latter part of his life at least, he was tutor or servitor to MacDonalds of Antrim. A lament composed in bardic metre and language for the well-known Armagh poet, Patrick MacAlionduin, who died in 1733, is attributed in several Irish manuscripts to "), _c('em', [_vm._v("Fearghus MacBeatha")]), _vm._v("."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn114",
      "id": "rfn114"
    }
  }, [_c('sup', [_vm._v("114")])]), _vm._v(" Finally, Dr. William MacBeath of Washington assures me that, although his family believe themselves to be of Scottish origin ultimately, their earliest ancestor in North America was Andrew MacBeth who came over from Northern Ireland sometime in the "), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }), _vm._v("eighteenth century. The names "), _c('em', [_vm._v("Fergus")]), _vm._v(" and "), _c('em', [_vm._v("Andrew")]), _vm._v(" are typical of the island division of the Beaton kindred, while the continued use of the surname "), _c('em', [_vm._v("MacBeth")]), _vm._v(" reflects Christopher’s known preference in this matter.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There follows the pedigree of the Beatons of North Uist from Fergus Fionn:")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Illustration",
      "src": "images/f0021-01.png"
    }
  })]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "sec4"
    }
  }), _vm._v("Beatons of Connista (Pedigree II)")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The second pedigree in the Laing MS begins Fergus, son of John, son of Donald, son of John who was head of the Beatons of Ballenabe in 1563. On 4 October 1660 John Beaton, “chirurgen, indueler in Connasta”, Trotternish, discharged Donald MacDonald of Moidart for £100 for the maintenance of Fergus “my lawfull sone at the colledge”."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn115",
      "id": "rfn115"
    }
  }, [_c('sup', [_vm._v("115")])]), _vm._v(" The £100 which came from Clan Ranald teinds in South Uist, was assigned for the aforementioned purpose by the presbytery of Skye, acting through Mr Archibald MacQueen, minister of Kilmory in Trotternish and “collector of tithes in South Uist and Benbecula”."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn116",
      "id": "rfn116"
    }
  }, [_c('sup', [_vm._v("116")])]), _vm._v(" The discharge was written at Ormacleit in South Uist. John Beaton “of Conasta, phisitiane”, had witnessed and signed another discharge to John MacDonald of Moidart, also written at Ormacleit, on 30 July 1658."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn117",
      "id": "rfn117"
    }
  }, [_c('sup', [_vm._v("117")])]), _vm._v(" He witnessed and probably also signed a discharge by Mr Archibald MacQueen on 15 February 1659"), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn118",
      "id": "rfn118"
    }
  }, [_c('sup', [_vm._v("118")])]), _vm._v(" and another on 28 August 1660 along with Sir James MacDonald "), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }), _vm._v("of Sleat."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn119",
      "id": "rfn119"
    }
  }, [_c('sup', [_vm._v("119")])]), _vm._v(" Two days later he and Sir James MacDonald witnessed a bond by Donald MacDonald of Moidart to Mr Archibald MacQueen."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn120",
      "id": "rfn120"
    }
  }, [_c('sup', [_vm._v("120")])]), _vm._v(" Trotternish was Clan Donald of Sleat territory and clearly John Beaton was employed by them. But his connection with the Clan Ranald, specifically in the person of Donald MacDonald of Moidart, son and heir of their chief, John Muideartach, was probably of long standing, for, in the Red Book of Clanranald, Neill MacMhuirich states that “Eoin mac Domnuill Mheigbhethadh” was one of the "), _c('em', [_vm._v("daoin-uaisle")]), _vm._v(" or noblemen who accompanied Donald MacDonald on a military expedition to Ireland in 1648."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn121",
      "id": "rfn121"
    }
  }, [_c('sup', [_vm._v("121")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The epithet "), _c('em', [_vm._v("Faghlach")]), _vm._v(" that MacMhuirich gave to John’s father, Donald, was translated ‘of Benbecula’ by his editor."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn122",
      "id": "rfn122"
    }
  }, [_c('sup', [_vm._v("122")])]), _vm._v(" However, to be grammatically correct in this context, MacMhuirich should have written "), _c('em', [_vm._v("Fhaghlaich")]), _vm._v(". But he was probably guilty of no more than a simple error of omission, for Christopher Beaton, copying this passage into the Black Book of Clanranald, inserted the definite article "), _c('em', [_vm._v("na")]), _vm._v(" between "), _c('em', [_vm._v("Domnuill")]), _vm._v(" and "), _c('em', [_vm._v("Faghlach")]), _vm._v(","), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn123",
      "id": "rfn123"
    }
  }, [_c('sup', [_vm._v("123")])]), _vm._v(" so correctly ‘Donald of the "), _c('em', [_vm._v("fadhail")]), _vm._v("’, while Donald himself signed his name in the Laing MS “Domhnall na Faghlach maig bheathad”."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn124",
      "id": "rfn124"
    }
  }, [_c('sup', [_vm._v("124")])]), _vm._v(" Clearly Christopher knew exactly who John Beaton was, and his interest in him is betrayed by the fact that he shortened MacMhuirich’s list of "), _c('em', [_vm._v("daoin-uaisle")]), _vm._v(" before John Beaton’s name was reached and omitted altogether those named after him. "), _c('em', [_vm._v("Fadhail")]), _vm._v(", sometimes translated ‘ford’, more correctly describes a channel of running water left behind in the sand as the tide ebbs and normally fordable. There are, of course, notable "), _c('em', [_vm._v("fadhlaichean")]), _vm._v(" between Benbecula and the Uists but it is not possible to identify the one associated with Donald’s name. Its use here probably commemorates an incident in which he was involved at or crossing a "), _c('em', [_vm._v("fadhail.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Fergus Beaton signed his father’s discharge for the £100 received towards his education in 1660 but owing to a tear in the paper only part of his signature is now visible. It is likely that he was the Fergus Beaton who matriculated at Glasgow University in 1661 and graduated M.A. in 1664."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn125",
      "id": "rfn125"
    }
  }, [_c('sup', [_vm._v("125")])]), _vm._v(" It was doubtless intended that he should proceed to the ministry but no further record of him has come to light. Clearly he had become head of the family sometime before 1670, the last possible year in which Christopher could have written the Laing MS pedigrees. Presumably, his "), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }), _vm._v("father had died in the interval and his only clearly visible signature dated 1660 is shaky and looks like that of an old man."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn126",
      "id": "rfn126"
    }
  }, [_c('sup', [_vm._v("126")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Gill-Anndrais, son of Donald, son of John, who signed MS XXIX thus, was probably Fergus’s uncle."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn127",
      "id": "rfn127"
    }
  }, [_c('sup', [_vm._v("127")])]), _vm._v(" It has already been pointed out that MS XXIX, originally a Pennycross manuscript, had by this time come north to Clan Ranald and Clan Donald of Sleat territory where it was signed by the Clan Ranald poet, Neill MacMhuirich, by Christopher’s brother, Neill, and probably also, as will be seen, by a member of the South Uist branch of the Beaton kindred."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn128",
      "id": "rfn128"
    }
  }, [_c('sup', [_vm._v("128")])]), _vm._v(" A comparison of handwriting indicates that as Gill-Anndrais Dubh he claimed ownership of MS XXVII."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn129",
      "id": "rfn129"
    }
  }, [_c('sup', [_vm._v("129")])]), _vm._v(" It was presumably his son, Neill, who was owner of MS XIV,"), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn130",
      "id": "rfn130"
    }
  }, [_c('sup', [_vm._v("130")])]), _vm._v(" for its cover and that of MS XXVII, on which this information was written, were made in part from the same late twelfth or early thirteenth century vellum manuscript."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn131",
      "id": "rfn131"
    }
  }, [_c('sup', [_vm._v("131")])]), _vm._v(" That Gill-Anndrais and Neill belonged to this period is also suggested by the late and coarse character of Neill’s Gaelic script, while the Gaelic of his signature, "), _c('em', [_vm._v("Neall mak Giolla Anndrais")]), _vm._v(", is orthographically inaccurate, indicating that he stood at the end of the classical tradition. Nevertheless he may have been a doctor of note, for according to eighteenth century tradition, Neill Beaton, “a man of extensive knowledge and ability in the medical profession” and located in Skye, was physician to Sir James Mór MacDonald of Sleat (1643–78)."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn132",
      "id": "rfn132"
    }
  }, [_c('sup', [_vm._v("132")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There follows the pedigree of the Beatons of Connista from Fergus Fionn:")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Illustration",
      "src": "images/f0023-01.png"
    }
  })]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }), _c('a', {
    attrs: {
      "id": "sec5"
    }
  }), _vm._v("Beatons in Sleat (Pedigree III)")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("John was the name of the Beaton whose pedigree this is. John Beaton “chirurgeon in Sleat” signed a bond by Donald, eldest son of Sir Donald MacDonald of Sleat, on 3 March 1690."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn133",
      "id": "rfn133"
    }
  }, [_c('sup', [_vm._v("133")])]), _vm._v(" But John was doubtless an adult and presumably also head of his family when Christopher Beaton wrote the pedigree, for John’s sons, Donald and James, witnessed and signed a contract of wadsett between Sir Donald of Sleat and John Martin, tacksman of Kingsburgh, on 23 January 1697."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn134",
      "id": "rfn134"
    }
  }, [_c('sup', [_vm._v("134")])]), _vm._v(" James had signed a document in the previous year as servitor to Sir Donald of Sleat."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn135",
      "id": "rfn135"
    }
  }, [_c('sup', [_vm._v("135")])]), _vm._v(" On 22 September 1716, Donald, as “Doctor of Medicine”, wrote and signed a certificate in Sleat testifying to the “very bad state of health” in which Sir Donald was at that time."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn136",
      "id": "rfn136"
    }
  }, [_c('sup', [_vm._v("136")])]), _vm._v(" Donald was probably the older of the two brothers. Not only did he sign the wadsett of 1697 before James but, as the older son, he was likely to be named after his grandfather, also Donald, according to the pedigree. His grandfather was a son of Gill-Anndrais, son of Gille-Coluim, son of Eoin Maol, son of Gille-Coluim, son of Eoin Liath, son of Gille-Coluim Cléireach who has already been equated with Gille-Coluim Leich living in the Islay parish of Kilchoman in the year 1541."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn137",
      "id": "rfn137"
    }
  }, [_c('sup', [_vm._v("137")])]), _vm._v(" This pedigree is exceptional in that it numbers ten generations including Fergus Fionn as compared with six or seven for the other five. However, the careful use of epithets prohibits proposing that repetition of the names "), _c('em', [_vm._v("Eoin")]), _vm._v(" and "), _c('em', [_vm._v("Gille-Coluim")]), _vm._v(" in this pedigree should be considered an error. Its length can be partly explained by the fact that John was obviously a relatively young man when he became head of his family sometime before 1670, for he was still alive in 1697."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn138",
      "id": "rfn138"
    }
  }, [_c('sup', [_vm._v("138")])]), _vm._v(" In other words he was almost an exact contemporary of Christopher who does not figure in pedigree I, presumably because his own father was still alive at the time of writing. In conclusion it is worth noting that the authors of "), _c('em', [_vm._v("Clan Donald")]), _vm._v(" refer to “a long succession” of Beaton doctors in Sleat."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn139",
      "id": "rfn139"
    }
  }, [_c('sup', [_vm._v("139")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("None of the documents quoted above indicate where in Sleat this family lived but the judicial rental of 21 August 1733 names Malcolm and Neill Beaton and Neill’s sister, Mary, as tenants in Tarskvagmore."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn140",
      "id": "rfn140"
    }
  }, [_c('sup', [_vm._v("140")])]), _vm._v(" It is "), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }), _vm._v("perhaps not without significance, in view of the family’s previous employment by MacDonald of Sleat, that Malcolm MacIntyre, “the Laird’s piper”, was also a tenant in Tarskvagmore. There is no indication that Neill or Malcolm practised medicine, and it may be that Donald was the last physician of his line.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There follows the pedigree of the Beatons in Sleat from Fergus Fionn:")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Illustration",
      "src": "images/f0025-01.png"
    }
  })]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "sec6"
    }
  }), _vm._v("Beatons of Pennycross (Pedigree IV)")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("This pedigree belongs to the Beatons of Pennycross in Mull, and there is more certain information about this family than for any other represented by the Laing MS pedigrees. They were, of course, one of the best-known Beaton medical families in the seventeenth century. But also important is the survival of documents associated with Neill Beaton’s claim made in 1760–1 to the Duke of Argyll to succeed to the lands of Pennycross. They consist of two memorials by Neill; the first, which includes an inventory of relevant writs, is dated 1760 and the second, an account of his medical training, is dated 1761. There are also two separate reports on these memorials by Campbell agents of the Duke of Argyll, the second of which is entitled “Genealogie of the Beatons of Peinnacross”."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn141",
      "id": "rfn141"
    }
  }, [_c('sup', [_vm._v("141")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }), _vm._v("Pedigree IV reads Fergus, son of Donald, son of Gille-Coluim, son of Gill-Anndrais, son of Donald Mór, son of Fergus Fionn. The earliest writ, dated 20 October 1572, records a grant of the lands of Pennycross in Brolas, Mull, by Hector MacLean of Duart to “Andrew MacDonel vik inoldif, his servant . . . together with the supreme and principall office of surgeon” within all the territories currently in the possession of the MacLeans of Duart. On 19 November 1603 “Malcolm vik inolduf mc bea, son of Andrew” was infefted in these same lands."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn142",
      "id": "rfn142"
    }
  }, [_c('sup', [_vm._v("142")])]), _vm._v(" Clearly Malcolm, son of Andrew, son of Donald, are the third, fourth and fifth steps of the above pedigree. Their alternative Gaelic surnames were "), _c('em', [_vm._v("MacBheatha")]), _vm._v(" and "), _c('em', [_vm._v("mac in oldif")]), _vm._v(" or "), _c('em', [_vm._v("Mac an ollaimh")]), _vm._v(", ‘son of the physician’. Pennycross continues to be remembered as the home of this Beaton family in Mull and indeed, the site of the house of "), _c('em', [_vm._v("an t-Ollamh Muileach")]), _vm._v(", ‘the Mull doctor’, could still be pointed out in recent times."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn143",
      "id": "rfn143"
    }
  }, [_c('sup', [_vm._v("143")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Andrew "), _c('em', [_vm._v("Mak in olliff")]), _vm._v(", doctor, witnessed a charter by Hector MacLean on 1 January 1574 but he was probably dead by 24 December 1582 when his son, Malcolm "), _c('em', [_vm._v("mac gillandreist")]), _vm._v(", doctor, witnessed a precept of sasine contained in a charter by Lachlan Mór MacLean of Duart."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn144",
      "id": "rfn144"
    }
  }, [_c('sup', [_vm._v("144")])]), _vm._v(" In that same year a wayside cross, traditionally associated with the Beatons and still known as "), _c('em', [_vm._v("Crois an Ollaimh")]), _vm._v(", ‘the physician’s cross’, was set up at Pennycross."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn145",
      "id": "rfn145"
    }
  }, [_c('sup', [_vm._v("145")])]), _vm._v(" The initials G M B above the date would stand for Gille-Coluim MacBheatha, while below the date D M B must surely be for Domhnall MacBheatha, Malcolm’s son in pedigree IV."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn146",
      "id": "rfn146"
    }
  }, [_c('sup', [_vm._v("146")])]), _vm._v(" Elsewhere in the Laing MS, it is recorded that in 1587 the manuscript belonged to Gille-Coluim, son of Gill-Anndrais, son of Donald MacBheatha,"), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn147",
      "id": "rfn147"
    }
  }, [_c('sup', [_vm._v("147")])]), _vm._v(" but perhaps the most convincing evidence that Malcolm had succeeded his father as principal physician to the MacLeans of Duart before his formal infeftment in the lands of Pennycross in 1603 comes in a Gaelic letter written to him sometime between 1593 and 1596 by Lachlan Mór MacLean of Duart, in which Lachlan Mór addresses him as ‘his personal physician’, although, as it happens, at the time of writing he was in attendance on members of the "), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }), _vm._v("family of Stewart of Appin."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn148",
      "id": "rfn148"
    }
  }, [_c('sup', [_vm._v("148")])]), _vm._v(" Finally, Malcolm was probably the same as “one Dr Beaton, the famous physician of Mull”, who, according to Martin Martin’s informants on that island, was sitting on the upper deck of the Spanish ship, "), _c('em', [_vm._v("Florida")]), _vm._v(", when it was blown up in Tobermory Bay in 1588 and yet was saved by “an admirable providence”."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn149",
      "id": "rfn149"
    }
  }, [_c('sup', [_vm._v("149")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The genealogical account included in the second report on Neill Beaton’s memorials to the Duke of Argyll in 1760–1, doubtless drawn up from information supplied by Neill, specifically states that Donald succeeded his father, Malcolm, in Pennycross, presumably sometime after 1603. However, the presence of his initials alongside those of his father on the cross of 1582 suggests that he was already an adult. He was probably also a fully qualified physician before his father died. A colophon to a medical treatise in MS XXXIII includes the scribe’s name written "), _c('em', [_vm._v("Domhnall mac an ollaimh")]), _vm._v(". Donald’s colophon was followed by an interlocking pattern to further mark completion of the work, and judging by the ink it was Donald himself who executed it. But the words “Leabhair Giolla Cholaim Meig beathadh”, ‘Gille-Coluim MacBeth’s book’, are written on either side of it in Malcolm’s handwriting."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn150",
      "id": "rfn150"
    }
  }, [_c('sup', [_vm._v("150")])]), _vm._v(" At the time of writing according to his colophon, Donald was in Donegal and presumably on his return to Scotland, he presented or restored the manuscript to his father.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("While in Donegal, Donald had enjoyed the company of "), _c('em', [_vm._v("Donnchadh Ulltach")]), _vm._v(" and "), _c('em', [_vm._v("Pfronsies Ulltach")]), _vm._v(", but his colophon states that he was now saddened, for he could ‘get no one to discuss a single word since they departed’."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn151",
      "id": "rfn151"
    }
  }, [_c('sup', [_vm._v("151")])]), _vm._v(" Clearly Duncan and Francis were medical men and almost certainly members of the MacDhuinnshléibhe family of hereditary physicians to the O’Donnels in Tyrconnell, Donegal."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn152",
      "id": "rfn152"
    }
  }, [_c('sup', [_vm._v("152")])]), _vm._v(" Already by the end of the fourteenth century the epithet "), _c('em', [_vm._v("Ulltach")]), _vm._v(" identified members of the family,"), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn153",
      "id": "rfn153"
    }
  }, [_c('sup', [_vm._v("153")])]), _vm._v(" probably in recognition of their descent from the ruling kindred of twelfth century Ulidia (Cos. Antrim and Down)."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn154",
      "id": "rfn154"
    }
  }, [_c('sup', [_vm._v("154")])]), _vm._v(" Duncan, son of Eoghan Ulltach, physician to the O’Donnells, died in 1527."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn155",
      "id": "rfn155"
    }
  }, [_c('sup', [_vm._v("155")])]), _vm._v(" In 1586 "), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }), _vm._v("Eoghan Ulltach, son of Duncan, ‘the best physician in Ireland’, died."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn156",
      "id": "rfn156"
    }
  }, [_c('sup', [_vm._v("156")])]), _vm._v(" This is the last MacDhuinnshléibhe doctor mentioned in the annals and, in view of the progression of forenames, Duncan Ulltach of MS XXXIII is likely to have been Eoghan’s eldest son.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Alongside the Beaton pedigrees in the Laing MS, Christopher wrote: “Hic Liber est Fergusii McVeagh, habitantis Peanagross”."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn157",
      "id": "rfn157"
    }
  }, [_c('sup', [_vm._v("157")])]), _vm._v(" This can only be Donald’s son and the final step of pedigree IV. The Laing MS itself was written for John Beaton of Ballenabe by Cairbre Ó Ceandamháin probably in or about 1563,"), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn158",
      "id": "rfn158"
    }
  }, [_c('sup', [_vm._v("158")])]), _vm._v(" the year in which a companion volume was written for the same John Beaton by Cairbre Ó Ceandamháin and others."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn159",
      "id": "rfn159"
    }
  }, [_c('sup', [_vm._v("159")])]), _vm._v(" The genealogical account of 1760–1 maintains that Andrew was the first of the family to possess the lands of Pennycross, and there is no record of any other Fergus therein.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The genealogical account just mentioned confirms the Pennycross descent from Andrew to Fergus, adding that Malcolm, son of Andrew, had, besides Donald, a younger son named John. An inscription on a graveslab on Iona reads:")]), _vm._v(" "), _c('div', {
    staticClass: "move"
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("“Hie iacet Ioannes Betonus, Maclenorum familie medicus, qui mortuus est 19 Novembris anno domini 1657 et etatis sue 63. Donaldus Betonus me fecet 1674”."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn160",
      "id": "rfn160"
    }
  }, [_c('sup', [_vm._v("160")])])]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("‘Here lies John Beaton, physician to the family of the MacLeans, who died on 19 November 1657 aged 63. Donald Beaton made me, 1674’.")])]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("Writing in Latin and claiming ownership of MS XXIX, John Beaton gave the date of his birth as 1594, which agrees with the evidence of the inscription."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn161",
      "id": "rfn161"
    }
  }, [_c('sup', [_vm._v("161")])]), _vm._v(" In 1651 the "), _c('em', [_vm._v("Minutes of the Synod of Argyll")]), _vm._v(" mention “John Beaton, physician, living within the parish of Kilvickewan”, which contains Pennycross."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn162",
      "id": "rfn162"
    }
  }, [_c('sup', [_vm._v("162")])]), _vm._v(" Clearly John Beaton, born to Malcolm in 1594 and therefore considerably younger than his brother Donald, had succeeded to the position of principal physician to the MacLeans of Duart and therefore also to the lands of Pennycross. This had probably happened by 1633, for two bonds in that year by Sir Lachlan MacLean, dated 30 June and 13 July "), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }), _vm._v("respectively, were signed in Latin by John Beaton as his servitor."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn163",
      "id": "rfn163"
    }
  }, [_c('sup', [_vm._v("163")])]), _vm._v(" It was probably he who signed his name in Gaelic on MS II as "), _c('em', [_vm._v("Eoin mac mhic bhethadh")]), _vm._v(", reverting to the original form of his Gaelic surname, long since abandoned by his kindred."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn164",
      "id": "rfn164"
    }
  }, [_c('sup', [_vm._v("164")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The genealogical account of 1760–1 names three sons of John in the following order, John, Abraham and James. But the minute of the Synod of Argyll already quoted ordered that “10 bolls victual” be awarded to John, second son of John Beaton, physician, in order to maintain him at the grammar school of Inveraray. This was John Beaton who was to become minister of Kilninian in Mull and of whom more later."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn165",
      "id": "rfn165"
    }
  }, [_c('sup', [_vm._v("165")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Who, then, was the first son of John Beaton? Canadian descendants of William Beaton born in Mull c.1774 have preserved a pedigree recording six generations of his ancestors. His father was Donald, son of William, son of James, son of Donald, son of Neill, son of John."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn166",
      "id": "rfn166"
    }
  }, [_c('sup', [_vm._v("166")])]), _vm._v(" The average thirty years to a generation subtracted from 1774 brings us back to 1594, by a nice coincidence the year of John Beaton’s birth. That the last step of the pedigree and John Beaton of Pennycross are one and the same is made more likely by the fact that in 1656, the year before John Beaton died, Neill Beaton was appointed by the Synod of Argyll to be factor for uplifting the teinds during the vacancy in Kilfinichen, the neighbouring parish to Kilvickewan."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn167",
      "id": "rfn167"
    }
  }, [_c('sup', [_vm._v("167")])]), _vm._v(" The handwriting of "), _c('em', [_vm._v("Niall mac an ollaimh")]), _vm._v(", as he signed his name in the Pennycross manuscript MS II, post-dates that of John Ó Conchobhair of Ardeoran elsewhere in the same manuscript."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn168",
      "id": "rfn168"
    }
  }, [_c('sup', [_vm._v("168")])]), _vm._v(" The latter was apparently still alive in 1607 but dead by 1621."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn169",
      "id": "rfn169"
    }
  }, [_c('sup', [_vm._v("169")])]), _vm._v(" Moreover, it will be seen that Neill was probably a pupil of James Beaton of Dervaig (1613 x "), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }), _vm._v("15–21) and a younger contemporary of Angus Beaton of Husabost (1641)."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn170",
      "id": "rfn170"
    }
  }, [_c('sup', [_vm._v("170")])]), _vm._v(" Finally, Neill is the only possible candidate of that name in the Pennycross family by this time.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Donald, son of Neill, of the Canadian pedigree was doubtless the Donald Beaton who was in Pennycross in 1675"), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn171",
      "id": "rfn171"
    }
  }, [_c('sup', [_vm._v("171")])]), _vm._v(" and who was responsible for commissioning John Beaton’s graveslab in 1674. It was almost certainly he who, partly in Gaelic script and partly in a late Roman hand, signed himself Donald, son of Neill, in English in Add. 15,582,"), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn172",
      "id": "rfn172"
    }
  }, [_c('sup', [_vm._v("172")])]), _vm._v(" the manuscript which was perhaps presented to Fergus, Donald’s predecessor in Pennycross, by Christopher Beaton."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn173",
      "id": "rfn173"
    }
  }, [_c('sup', [_vm._v("173")])]), _vm._v(" He is also the only recorded Pennycross Beaton of that forename who could have signed the Laing MS in Gaelic script as "), _c('em', [_vm._v("Domhnall MacBethadh")]), _vm._v(" on 1 September 1657. If so, he was a young man of hardly more than twenty years of age, given his grandfather’s date of birth in 1594."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn174",
      "id": "rfn174"
    }
  }, [_c('sup', [_vm._v("174")])]), _vm._v(" However, he had obviously already received some classical training, possibly from his grandfather, "), _c('em', [_vm._v("an t-Ollamh Muileach")]), _vm._v(", shortly to die, although his father and their cousin, Fergus, who would succeed in Pennycross, were also qualified physicians by this time.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the pedigree Donald is given a son James who must be the same as James Beaton praised in an "), _c('em', [_vm._v("iorram")]), _vm._v(" or ‘work song’ included in "), _c('em', [_vm._v("Sàr-Obair nam Bàrd")]), _vm._v(" by John MacKenzie as the only example of its genre."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn175",
      "id": "rfn175"
    }
  }, [_c('sup', [_vm._v("175")])]), _vm._v(" The song is entitled “Iorram do Sheumas Beaton, iar-odha do’n Olla Mhuileach”, ‘"), _c('em', [_vm._v("iorram")]), _vm._v(" to James Beaton, great-grandson of the "), _c('em', [_vm._v("Ollamh Muileach")]), _vm._v("’. James is also mentioned by name in the body of the song and is described there as “car’ an olla Mhuileach”, ‘kinsman of the "), _c('em', [_vm._v("Ollamh Muileach")]), _vm._v("’. James of the pedigree was a great-grandson of John who will be shown to be the last to hold the post of "), _c('em', [_vm._v("Ollamh Muileach")]), _vm._v("."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn176",
      "id": "rfn176"
    }
  }, [_c('sup', [_vm._v("176")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The text makes it clear that the song was composed in James Beaton’s lifetime and the content, format and language are in keeping with an origin in the seventeenth century, generally recognised to have been the high point of the composition of the "), _c('em', [_vm._v("iorram")]), _vm._v("."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn177",
      "id": "rfn177"
    }
  }, [_c('sup', [_vm._v("177")])]), _vm._v(" That it was composed sometime towards the end of that century is suggested by the presence in the text of "), _c('em', [_vm._v("Beatonach")]), _vm._v(", a Gaelicised form of the surname "), _c('em', [_vm._v("Beaton")]), _vm._v(". The first syllable of "), _c('em', [_vm._v("Beatonach")]), _vm._v(" was intended to assonate with "), _c('em', [_vm._v("beus")]), _vm._v(" and the first syllable of "), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }), _c('em', [_vm._v("Seumas")]), _vm._v(" of the previous two lines and is therefore long, as it continues to be in "), _c('em', [_vm._v("Peutanach")]), _vm._v(", the form normally written today. This represents the pronunciation almost everywhere except in Argyll where the first syllable more closely resembles that in "), _c('em', [_vm._v("Beaton")]), _vm._v("."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn178",
      "id": "rfn178"
    }
  }, [_c('sup', [_vm._v("178")])]), _vm._v(" It is interesting, therefore, that the only other possible seventeenth century example known to me of this surname borrowed into Gaelic was "), _c('em', [_vm._v("Bithunach")]), _vm._v(" written by Mr John Beaton, minister of Kilninian (d. 1714)."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn179",
      "id": "rfn179"
    }
  }, [_c('sup', [_vm._v("179")])]), _vm._v(" Judging by the spelling it retained something of the Scots pronunciation of "), _c('em', [_vm._v("Beaton")]), _vm._v(", perhaps even influenced by the French variant "), _c('em', [_vm._v("Bethune")]), _vm._v(". At any rate it seems likely that the present written Gaelic form "), _c('em', [_vm._v("Peutanach")]), _vm._v(" had not yet stabilised and that "), _c('em', [_vm._v("Beaton")]), _vm._v(" had only recently been Gaelicised.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The northern provenance of the song version of the surname "), _c('em', [_vm._v("Beaton")]), _vm._v(" becomes significant in light of Martin Martin’s report of a conversation that he had c.1695 with James Beaton, who was “then surgeon in the Isle of North Uist”."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn180",
      "id": "rfn180"
    }
  }, [_c('sup', [_vm._v("180")])]), _vm._v(" James Beaton told him that, “being in the isle of Mull”, he was “called by some of the MacLeans to go along with them to attack a vessel belonging to the Earl of Argyll who was then coming to possess Mull by force”. This can be none other than the ship carrying provisions from Leith in support of the projected Campbell expedition to Mull in 1675 which was attacked by the MacLeans in the month of September off the coast of Ardnamurchan."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn181",
      "id": "rfn181"
    }
  }, [_c('sup', [_vm._v("181")])]), _vm._v(" James Beaton’s account makes it clear that he was already practising medicine. If, as seems likely, he was John Beaton’s great-grandson, either he or his son or grandson must have returned to settle in Mull to allow William of the Canadian pedigree to be born there. In presenting his claim in 1760–1 to the Duke of Argyll to succeed to Pennycross, Neill Beaton, third son of Mr John Beaton, minister of Kilninian, although, with one important exception, apparently accurate in tracing his family’s descent from Andrew, misrepresented or misunderstood the way in which succession to Pennycross had operated in the past. Thus, he maintained that it had passed in a straight line from Malcolm to Donald to Fergus and from thence to Fergus’s son, another Malcolm, who died, according to Neill, in 1725 or 1726. This date is wrong but it will be seen that Malcolm did live into the eighteenth century. The possession of Pennycross by Neill’s own grandfather, John, and by his first cousin, Donald, is nowhere mentioned. It is possible that Neill was not aware that his grandfather had possessed Pennycross, since this would have "), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }), _vm._v("strengthened his own claim, but it is difficult to believe that the omission of Donald and his father, Neill, after whom he himself was doubtless named, from the genealogical account was not deliberate, especially as it has been shown that they did have descendants who may have been in Mull at the time and who had a better claim to Pennycross than Neill himself in terms of the prevailing system of succession."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn182",
      "id": "rfn182"
    }
  }, [_c('sup', [_vm._v("182")])]), _vm._v(" That Neill was capable of deliberate misrepresentation is only too clearly manifested in a dispute which he initiated concerning moneys that he considered his due as heir to his brother Edmund in Pennycross. In 1765, altering the date of Malcolm’s infeftment in Pennycross from 1603 to 1663, he claimed that Malcolm was his grandfather, that Donald, Malcolm’s elder son, died without issue and that John, second son of Malcolm, was the minister of Kilninian and his father. He stumbled only once when later in the same document he referred inadvertently but correctly to Malcolm as his great-grandfather."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn183",
      "id": "rfn183"
    }
  }, [_c('sup', [_vm._v("183")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But succession to Pennycross in the seventeenth century can only be satisfactorily explained in terms of the kin-based society whereby, in theory at least, the fittest man should succeed. This system of succession is, in any case, more likely to have survived longest among families practising a profession or craft on an hereditary basis and whose possession of lands depended on their ability to produce a skilled exponent in each succeeding generation. Therefore, Malcolm, son of Andrew, was doubtless succeeded by the older of his two sons, Donald, but Donald’s successor, within the Pennycross family at least,"), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn184",
      "id": "rfn184"
    }
  }, [_c('sup', [_vm._v("184")])]), _vm._v(" was almost certainly his brother, John, rather than his son, Fergus. Fergus presumably succeeded his uncle on the latter’s death in 1657. This allows Fergus to have a son in Pennycross who lived into the eighteenth century.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The explanation for the delay in commissioning John Beaton’s graveslab until 1674 was probably that Donald had only just succeeded Fergus in Pennycross, and this further implies that Donald’s father, Neill, was already dead and had not himself ever possessed Pennycross. Donald was certainly dead by 1702 when Mr John MacLean, minister of Kilninian, described Mr John Beaton, his friend and predecessor as minister in the parish and Donald’s uncle, as being the last scholar of the Beaton family in Mull."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn185",
      "id": "rfn185"
    }
  }, [_c('sup', [_vm._v("185")])]), _vm._v(" However, he also says that “they yet enjoy” the lands that they had once held in virtue of being physicians. This is clearly a reference to Malcolm, son of Fergus, in Pennycross. Neill Beaton claimed that his father, although he survived Malcolm, never actually succeeded to "), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }), _vm._v("Pennycross because Malcolm’s mother continued to enjoy a life-rent of the property, and on his death in 1714 John was living at Torrelock in the parish of Kilninian."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn186",
      "id": "rfn186"
    }
  }, [_c('sup', [_vm._v("186")])]), _vm._v(" Malcolm must have died sometime between 1702 and 1714. It is true that the defendants in the dispute initiated by Neill Beaton stated that Malcolm died “without heirs” in 1718, after which “the lands (of Pennycross) stood for sometime waste without any person claiming right to them” until in 1719 Sir Hector MacLean of Duart repossessed them."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn187",
      "id": "rfn187"
    }
  }, [_c('sup', [_vm._v("187")])]), _vm._v(" But it seems more likely, since there is no reason for doubting Neill’s order of events in this instance, that 1718 was the year in which Malcolm’s mother died.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Whatever the case the Beaton heir to Pennycross was now Edmund, eldest son of Mr John Beaton, who being “then very young, Sir Hector MacLean caused take care of him and applyed the rents of Peinnacross for three years towards breeding him a surgeon”. However, he “ran off from his apprenticeship to England”."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn188",
      "id": "rfn188"
    }
  }, [_c('sup', [_vm._v("188")])]), _vm._v(" On 13 January 1732 Sir Hector MacLean disponed the lands of Pennycross to Lachlan MacLean, merchant in Glasgow, for the sum of £100 sterling, who in turn, and certainly by 1750, had wadsett them to John MacLean of Treshnish."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn189",
      "id": "rfn189"
    }
  }, [_c('sup', [_vm._v("189")])]), _vm._v(" Perhaps as early as 1731 it was pointed out that, because Pennycross was an integral part of the wadsett of Brolas and therefore the property of the Duke of Argyll, Sir Hector MacLean had no right to intromit with the rents thereof."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn190",
      "id": "rfn190"
    }
  }, [_c('sup', [_vm._v("190")])]), _vm._v(" But it was not until 1756 that Argyll acted, taking the lands of Pennycross into his own hands “as being properly superior” thereof and dispossessing Lachlan MacLean and, presumably at the same time, the wadsetter, John McLean of Treshnish."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn191",
      "id": "rfn191"
    }
  }, [_c('sup', [_vm._v("191")])]), _vm._v(" When Neill Beaton turned up in 1760 to put his claim to Pennycross before the Duke, he maintained that his brother, Edmund, had only died in 1755 and that he was now the rightful heir."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn192",
      "id": "rfn192"
    }
  }, [_c('sup', [_vm._v("192")])]), _vm._v(" Mr Archibald Campbell, writer to the signet and author of the first report on Neill Beaton’s two memorials, came to the conclusion that Neill had “sufficiently proved his propinquity to his predecessors” "), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }), _vm._v("and recommended that a precept of "), _c('em', [_vm._v("clare constat")]), _vm._v(" be given to him as rightful heir to his great-grandfather, Malcolm, the second and last of the family to be formally infeft in the lands of Pennycross. Neill was duly put in possession of Pennycross, perhaps on 7 December 1761, for that was the date of a discharge by him to the Duke of Argyll relieving the latter of paying rent for the year 1761 and “all preceeding years”."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn193",
      "id": "rfn193"
    }
  }, [_c('sup', [_vm._v("193")])]), _vm._v(" In 1762, however, Neill began legal proceedings to recover the rents of Pennycross for the years 1726 to 1756 inclusive from Lachlan MacLean, merchant in Glasgow, and John MacLean of Killean, factor to MacLean of Duart. He also sued for damages of £50 sterling from the latter for “carrying off from the Mansion House of Piencross some wooden partitions and joists”."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn194",
      "id": "rfn194"
    }
  }, [_c('sup', [_vm._v("194")])]), _vm._v(" He was still trying to obtain payment of these moneys in 1767, although he had sold Pennycross for £300 sterling to Mr Archibald Lambie, minister of Kilmartin on 30 June 1764."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn195",
      "id": "rfn195"
    }
  }, [_c('sup', [_vm._v("195")])]), _vm._v(" Neill’s will written by him in Edinburgh on 13 February 1765 nominating his wife, Martha Hall, as sole executor was registered on 6 October 1768, which suggests that he had died earlier in that year."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn196",
      "id": "rfn196"
    }
  }, [_c('sup', [_vm._v("196")])]), _vm._v(" Pennycross had already returned to the medical profession, for, in April of 1765, Alexander MacLean, surgeon in Brolas, was congratulated by his first cousin, Hector MacLean of Grulin, also a physician, for his purchase thereof."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn197",
      "id": "rfn197"
    }
  }, [_c('sup', [_vm._v("197")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Neill also based his claim to succeed to Pennycross on the fact that he was “skilled in Bottany and other parts of surgery”, and to prove his point he went into his medical career in some detail. Archibald Campbell, quoting the relevant passage from what seems to have been the original Latin charter that recorded the grant of the lands of Pennycross in 1572 to Andrew Beaton “una cum supremo et principali officio medicinali vulgariter "), _c('em', [_vm._v("Ardollwnaght")]), _vm._v(" ("), _c('em', [_vm._v("ardollamhnachd")]), _vm._v(") infra limites omnium et singularium . . . terrarum de Mull, Morvern, Tirrie, Ilay, Jura, Lwyng, Argour et Lochaber”, goes on to say that “this does not now seem very material because as the law stands . . . his Grace cannot confirm to the memorialist this exclusive priveledge of a surgeon or practiser in medicine ovir the bounds granted in this charter”. In fact there is evidence to show that it was long before Neill’s time that the office of "), _c('em', [_vm._v("ardollamhnachd")]), _vm._v(" was "), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }), _vm._v("last filled. Sir Hector MacLean’s specific reason for granting Pennycross to other than Beatons in 1732 was that none of them had been “entered with me or my predecessours for these fourty years and upwards”."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn198",
      "id": "rfn198"
    }
  }, [_c('sup', [_vm._v("198")])]), _vm._v(" He clearly meant by this the office of principal physician, for he must have been aware that there were still Beatons in Pennycross at a much later date. Writing in 1702 of the Beatons and of the Ó Muirgheasains, who were poets and "), _c('em', [_vm._v("seanchaidhean")]), _vm._v(" to the MacLeans of Duart in the seventeenth century and earlier, Mr John MacLean states that Maol-Domhnaich Ó Muirgheasain died about forty years before that, that is, c.1662, and implies that he was the last person to fill either office."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn199",
      "id": "rfn199"
    }
  }, [_c('sup', [_vm._v("199")])]), _vm._v(" If this is correct, John Beaton, who died in 1657, was the last to fill the office of principal physician. The early nineteenth century tradition that John was “the last of the eminent race of the Pennycross physicians” is therefore probably a record of the fact that he had no successor as principal physician to the MacLeans of Duart."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn200",
      "id": "rfn200"
    }
  }, [_c('sup', [_vm._v("200")])]), _vm._v(" Entries in Gaelic medical manuscripts indicate that Fergus and Donald, who succeeded him in Pennycross, continued to practise medicine, although probably in reduced circumstances."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn201",
      "id": "rfn201"
    }
  }, [_c('sup', [_vm._v("201")])]), _vm._v(" Fergus is called simply "), _c('em', [_vm._v("habitans Peanagross")]), _vm._v(", ‘inhabitant of Pennycross’, by Christopher Beaton,"), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn202",
      "id": "rfn202"
    }
  }, [_c('sup', [_vm._v("202")])]), _vm._v(" while Donald, put to the horn as a rebel along with many others in Mull in 1675, is described in the letters of caption as “Donald Bittoune in Pennycross”, and another two inhabitants of Pennycross, apparently not Beatons, are also named therein."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn203",
      "id": "rfn203"
    }
  }, [_c('sup', [_vm._v("203")])]), _vm._v(" At the same time as their material circumstances suffered, their medical competence began to diminish, for Mr John MacLean states that the Beatons had the right to live at Pennycross “while they could so much as draw blood”, the implication being that Malcolm Beaton, John MacLean’s contemporary in Pennycross, was not competent to do much else. He confirms that Malcolm was not learned in the classical Gaelic tradition by going on to say that “Mr John Beaton, being the only scholar of their race has fallen to all their books and manuscripts”."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn204",
      "id": "rfn204"
    }
  }, [_c('sup', [_vm._v("204")])]), _vm._v(" Nowhere does Malcolm’s name appear in the surviving Pennycross manuscripts, and presumably John Beaton inherited them on the death of his nephew, Donald.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We first hear of John Beaton in 1651, attending grammar school in "), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }), _vm._v("Inveraray."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn205",
      "id": "rfn205"
    }
  }, [_c('sup', [_vm._v("205")])]), _vm._v(" If this was his first year at the school, as seems likely, then he was born c.1640, for boys went on to grammar school at about ten years of age."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn206",
      "id": "rfn206"
    }
  }, [_c('sup', [_vm._v("206")])]), _vm._v(" As already noted, he was clearly much younger than his older brother Neill, and he and his other brothers Abraham and James, of whom nothing further is heard, may have been the progeny of a second marriage made by their father. John graduated M.A. from Glasgow University in 1668 and was minister in the parish of Kilninian, Mull, by 1679."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn207",
      "id": "rfn207"
    }
  }, [_c('sup', [_vm._v("207")])]), _vm._v(" In that year he married Mary, daughter of the late James Kincaid, merchant and burgess in Glasgow, and he too became a burgess of the city."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn208",
      "id": "rfn208"
    }
  }, [_c('sup', [_vm._v("208")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He supported the MacLeans in their longstanding feud with the Campbells of Argyll and suffered thereby. The following remark that he wrote into MS III in 1677 may indeed be a comment on his condition as a result:")]), _vm._v(" "), _c('div', {
    staticClass: "movex"
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("“Is anroghach misi an dhiu aig fuacht agus aig ocris agus ni dom deoin . . .” ‘I am tormented this day by cold and hunger and not of my own will . . .’"), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn209",
      "id": "rfn209"
    }
  }, [_c('sup', [_vm._v("209")])])])]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("However, the forfeiture of the Earl of Argyll in 1681 lessened Campbell pressure for a time and John Beaton was one of four persons named by the Privy Council on 4 April 1682 to whom the Campbells were ordered to surrender captured MacLean arms, ammunition and strongholds, including Duart Castle."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn210",
      "id": "rfn210"
    }
  }, [_c('sup', [_vm._v("210")])]), _vm._v(" On 15 March of the following year he took the opportunity presented by these more favourable circumstances to petition the Privy Council on his own behalf, claiming that he was destitute “through the generall devastationes and hairshipes committed by the Campbells in Mull”, and he went on to demand that they secure peace on the island. The Privy Council agreed to compensate him with the stipends of the vacant mainland parishes of Kilninver and Kilmelfort for the year 1682."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn211",
      "id": "rfn211"
    }
  }, [_c('sup', [_vm._v("211")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It proved to be a short respite for the MacLeans, and John Beaton shared their renewed misfortunes at the hands of the Campbells. He composed a "), _c('a', {
    attrs: {
      "id": "page_37"
    }
  }), _vm._v("poem of twelve verses preserved in a manuscript collection of poetry, now in the Public Archives of Nova Scotia, but made in Mull c.1768 by the same Hector MacLean whose kinsman, Alexander, had recently obtained possession of Pennycross."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn212",
      "id": "rfn212"
    }
  }, [_c('sup', [_vm._v("212")])]), _vm._v(" Hector MacLean stated that the subject of the poem was “the Revolution and Silencing the Episcopall Ministers in Mull”, but in fact John Beaton devotes only one verse to his changed status as an Episcopalian minister following the Revolution Settlement of 1689–90 which included the establishment of the Presbyterian form of church government. He was clearly continuing to minister to his parishioners, but as he himself put it:")]), _vm._v(" "), _c('div', {
    staticClass: "move"
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("“’N déidh seirbheis na Sàbaide gun fios cia’nt t-àite ’n caidil e”."), _c('br'), _vm._v("‘after the Sabbath service he knows not where he will sleep’.")])]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("In the remainder of the poem he is concerned to describe the plight of the people of Mull but also to comfort them with the promise that God in Heaven watches over them and that the wheel of fortune will turn again. The Campbells mounted a devastating invasion of Mull in October of 1690, and on 31 March of the following year Sir John MacLean, chief of the clan, surrendered Duart Castle and was sent into exile."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn213",
      "id": "rfn213"
    }
  }, [_c('sup', [_vm._v("213")])]), _vm._v(" His exile is mentioned in the poem, although John Beaton was careful neither to name the clan nor any individual thereof directly, nor yet the Campbells to whom he refers simply as the enemies ("), _c('em', [_vm._v("eascairdean")]), _vm._v(") of the people of Mull.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Nor, for that matter, has he a word to say against Presbyterianism in the poem. His ambivalent attitude to the religious and political developments culminating in the Revolution Settlement appears again when he signed MS XX on 3 April 1690, adding that it was now:")]), _vm._v(" "), _c('div', {
    staticClass: "move"
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("‘the second year after the English and all the Protestants of Great Britain and Ireland . . . along with William, Prince of Orange, sent King James into exile for the sake of righteousness’."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn214",
      "id": "rfn214"
    }
  }, [_c('sup', [_vm._v("214")])])])]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("He accepted that James VII’s promotion of Roman Catholicism merited exile but he could not bring himself to address William as king. Eventually in 1697 we find him as “Episcopall incumbent in Mull” presenting an address to the Synod of Argyll “craveing to be received into ministerial communion”."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn215",
      "id": "rfn215"
    }
  }, [_c('sup', [_vm._v("215")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_38"
    }
  }), _vm._v("His petition was rejected, and in 1702 he was succeeded in the parish of Kilninian by his friend, Mr John MacLean."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn216",
      "id": "rfn216"
    }
  }, [_c('sup', [_vm._v("216")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But John Beaton had probably abandoned or been removed from his parish by 1700, for he himself records that he was in Coleraine, Co. Derry, on 22 April of that year."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn217",
      "id": "rfn217"
    }
  }, [_c('sup', [_vm._v("217")])]), _vm._v(" Edward Lhuyd met John Beaton in Northern Ireland, probably at Coleraine, earlier in 1700,"), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn218",
      "id": "rfn218"
    }
  }, [_c('sup', [_vm._v("218")])]), _vm._v(" certainly by 14 March, on which day the latter was writing, at the behest of Edward Lhuyd, Part XVI of manuscript H. 4. 22, now in Trinity College, Dublin."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn219",
      "id": "rfn219"
    }
  }, [_c('sup', [_vm._v("219")])]), _vm._v(" On this occasion Edward Lhuyd described him as “a poor sojourning clergyman”, and he may have been seeking an appointment in the Church of Ireland as did many another Scottish Episcopalian minister during this period.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("However, John Beaton eventually did return home, for, as already noted, he was living at Torrelock in the parish of Kilninian at his death in 1714. He may have returned in 1710, for the inventory in his testament names a number of prominent MacLeans, including Donald of Brolas, who owed his widow money as a result of obligating themselves in that year to make annual contributions to what was presumably a pension to support John in his old age."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn220",
      "id": "rfn220"
    }
  }, [_c('sup', [_vm._v("220")])]), _vm._v(" The testament also reveals that he was married a second time, to Alice MacKay,"), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn221",
      "id": "rfn221"
    }
  }, [_c('sup', [_vm._v("221")])]), _vm._v(" presumably the mother of his three sons. Edmund and Neill were the oldest and youngest respectively. The middle and unnamed son seems not to have survived him. Neill claimed to have been born only six months before his father’s death.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It is difficult to be precise about when John Beaton succeeded to the Pennycross manuscripts. If he signed MS III, a medical manuscript, in 1671,"), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn222",
      "id": "rfn222"
    }
  }, [_c('sup', [_vm._v("222")])]), _vm._v(" Fergus, his first cousin, was probably still alive and in Pennycross at this time. When he signed the same manuscript on 20 September 1677,"), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn223",
      "id": "rfn223"
    }
  }, [_c('sup', [_vm._v("223")])]), _vm._v(" it was doubtless his nephew, Donald, who was in Pennycross, having succeeded Fergus by 1674. On 3 April 1690 John Beaton signed MS XX,"), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn224",
      "id": "rfn224"
    }
  }, [_c('sup', [_vm._v("224")])]), _vm._v(" also mainly medical in content, but it was not until 22 April 1700 that he indicated his ownership of a Pennycross medical manuscript, namely MS XXXIII,"), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn225",
      "id": "rfn225"
    }
  }, [_c('sup', [_vm._v("225")])]), _vm._v(" and that we can be certain that Donald had died.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_39"
    }
  }), _vm._v("However, Donald was probably dead sometime before 1700, for Edward Lhuyd, while he was in Scotland in 1699, noted that ‘Mr John Beaton from Mull has a chest full of Gaelic books; most of them (almost all) are written on parchment, and they are in the Isle of Tiree now’."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn226",
      "id": "rfn226"
    }
  }, [_c('sup', [_vm._v("226")])]), _vm._v(" Lhuyd did not have access to them at this point, for there is no reason to believe that he visited Tiree. But John Beaton must have recovered them from there in the interval and brought them over to Ireland, for not only did he sign MS XXXIII at Coleraine on 22 April 1700, but he transcribed parts of both manuscripts which now comprise MS I for Edward Lhuyd when they met, presumably at Coleraine, earlier in that year."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn227",
      "id": "rfn227"
    }
  }, [_c('sup', [_vm._v("227")])]), _vm._v(" Moreover, Lhuyd made a list of some of John Beaton’s manuscripts, which included a detailed description of the second manuscript of MS I."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn228",
      "id": "rfn228"
    }
  }, [_c('sup', [_vm._v("228")])]), _vm._v(" Other comments as to the size and thickness of manuscripts imply that they were to hand. Significantly, no details of this kind are present in a section naming manuscripts that Beaton had lost.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The fact that John Beaton brought all or a considerable part of his library of manuscripts over to Ireland would seem to indicate that he intended making a protracted stay there, reinforcing the view that he may have had hopes of an appointment in the Church of Ireland. He was back in Mull sometime in 1701 or 1702 when John MacLean was able to consult him about a questionnaire on Gaelic matters drawn up by Robert Wodrow on 13 April 1701. But MacLean, in his reply to Wodrow written a year later, explained that the answers would have been more detailed, had John Beaton “his bookes beside him”."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn229",
      "id": "rfn229"
    }
  }, [_c('sup', [_vm._v("229")])]), _vm._v(" The implication is that his manuscripts were still in Ireland and that he intended returning there. Certainly a Pennycross medical manuscript, Add. 15,582, which was signed by John in 1708 and again dated by him on 20 June 1710,"), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn230",
      "id": "rfn230"
    }
  }, [_c('sup', [_vm._v("230")])]), _vm._v(" was bought by the British Museum in 1845 from the London bookseller, Thomas Rodd."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn231",
      "id": "rfn231"
    }
  }, [_c('sup', [_vm._v("231")])]), _vm._v(" It may never have been brought back to Scotland by John Beaton.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There follows the pedigree of the Beatons of Pennycross from Fergus Fionn. The figures in brackets indicate the order of succession to the lands of Pennycross:")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_40"
    }
  }), _c('img', {
    attrs: {
      "alt": "Illustration",
      "src": "images/f0040-01.png"
    }
  })]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "sec7"
    }
  }), _vm._v("Beatons in South Uist (Pedigree V)")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("This pedigree reads Gille-Coluim, son of Neill Bàn, son of Neill Glas, son of Gill-Anndrais, son of Gille-Coluim Cléireach who was probably on record in the Islay parish of Kilchoman in 1541."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn232",
      "id": "rfn232"
    }
  }, [_c('sup', [_vm._v("232")])]), _vm._v(" An undated document endorsed “Receipts & discharges of teinds (by) the ministers of Skye to John McDonald of Mudert Clanranald” gives a list of people in South Uist from whom teinds had been received, including Malcolm Beaton and his son."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn233",
      "id": "rfn233"
    }
  }, [_c('sup', [_vm._v("233")])]), _vm._v(" The Presbytery of Skye, which apparently included the Outer Hebrides in the seventeenth century, is meant by the reference to “the ministers of Skye”. Iain Muideartach, who became chief of Clan Ranald in 1618, died in 1670."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn234",
      "id": "rfn234"
    }
  }, [_c('sup', [_vm._v("234")])]), _vm._v(" However, the handwriting of the document belongs to the later rather than the earlier part of his long career. Furthermore, it is doubtful if the Presbytery of Skye received any teinds from South Uist much before 1660. Although Mr Martin MacPherson is on record as minister of South Uist in 1642, the Synod of Argyll in that year took note of the fact that the Captain of Clan Ranald had a “preest commonly resideing in his family”. In 1650 the Synod maintained that the parish had "), _c('a', {
    attrs: {
      "id": "page_41"
    }
  }), _vm._v("been vacant since 1643 and that the teinds thereof were “violently detained by that excommunicat rebell the Captaine of Clan Ranald”. In 1656 the Synod was still complaining about the open support shown by Iain Muideartach to Roman Catholic priests in his territories."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn235",
      "id": "rfn235"
    }
  }, [_c('sup', [_vm._v("235")])]), _vm._v(" The first discharge or receipt from the Presbytery for teinds from South Uist in the Clan Ranald muniments was given to Donald MacDonald, younger of Clan Ranald, on 15 February 1659 but it expressly excluded lands possessed by John of Moidart."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn236",
      "id": "rfn236"
    }
  }, [_c('sup', [_vm._v("236")])]), _vm._v(" All this means that the document, with which we are concerned, almost certainly belongs to the decade 1660 to 1670 and that therefore Malcolm Beaton mentioned therein should be equated with Gille-Coluim of the pedigree.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As "), _c('em', [_vm._v("Giolla coluim maig beath")]), _vm._v(", Malcolm probably signed MS XXIX."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn237",
      "id": "rfn237"
    }
  }, [_c('sup', [_vm._v("237")])]), _vm._v(" It has already been noted that Christopher Beaton may have brought this manuscript north with him from Pennycross and, since Neill MacMhuirich, Clan Ranald’s poet, signed it, what more likely than that the contemporary physician to Clan Ranald should have had similar access to it?"), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn238",
      "id": "rfn238"
    }
  }, [_c('sup', [_vm._v("238")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On 22 January 1684 no less than four Beatons, all described as servitors to Donald MacDonald of Moidart, witnessed and signed a discharge on Canna in the following order, Fergus, Neill, Donald and Neill."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn239",
      "id": "rfn239"
    }
  }, [_c('sup', [_vm._v("239")])]), _vm._v(" Fergus alone signed another document on the same day as “chirurgeon”."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn240",
      "id": "rfn240"
    }
  }, [_c('sup', [_vm._v("240")])]), _vm._v(" On 16 August 1683 he witnessed and signed a sasine to Donald MacDonald at Arisaig."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn241",
      "id": "rfn241"
    }
  }, [_c('sup', [_vm._v("241")])]), _vm._v(" Twelve days later he was described as “chirurgione in Uist”."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn242",
      "id": "rfn242"
    }
  }, [_c('sup', [_vm._v("242")])]), _vm._v(" Fergus was still “doctor of phisick in South Wist” on 9 April 1700,"), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn243",
      "id": "rfn243"
    }
  }, [_c('sup', [_vm._v("243")])]), _vm._v(" so that he is almost certainly the same as the physician of that name whom Martin Martin met in South Uist c.1695 and some of whose Gaelic manuscripts he listed."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn244",
      "id": "rfn244"
    }
  }, [_c('sup', [_vm._v("244")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The first Neill of the 1684 discharge, described as being from Uist, signed an execution of letters of horning against John MacLeod of Dunvegan on 16 September 1682."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn245",
      "id": "rfn245"
    }
  }, [_c('sup', [_vm._v("245")])]), _vm._v(" He was co-signatory with Fergus of the sasine at Arisaig on 16 August 1683."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn246",
      "id": "rfn246"
    }
  }, [_c('sup', [_vm._v("246")])]), _vm._v(" On 4 July 1682 and again on 27 August "), _c('a', {
    attrs: {
      "id": "page_42"
    }
  }), _vm._v("1684, he was recorded as an inhabitant of Uist, clearly South Uist, for he signed the second document along with Neill MacMhuirich and the first with Muireach MacMhuirich, member of a related family who served the MacDonalds of Balfinlay in Benbecula."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn247",
      "id": "rfn247"
    }
  }, [_c('sup', [_vm._v("247")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Donald, the third Beaton to sign the discharge on 22 January 1684, is recorded as living on Canna in a bond which he signed there on 9 February of that year."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn248",
      "id": "rfn248"
    }
  }, [_c('sup', [_vm._v("248")])]), _vm._v(" Appending what was obviously his normal signature to the discharge, in the bond he copied the very distinctive though old-fashioned capital ‘B’ used by Fearchar MacCulloch who was the writer of both documents. Fearchar or "), _c('em', [_vm._v("Ferquhard")]), _vm._v(", as he liked to spell his forename, was a notary public in Moidart, who did business, not only for the chief of Clan Ranald, but also for other important families in the area during much of the last quarter of the seventeenth century. His handwriting is elegant and easily recognised. It was clearly admired in his day, for, by a curious coincidence, his ‘B’ had been copied by another Donald Beaton from South Uist two years previously."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn249",
      "id": "rfn249"
    }
  }, [_c('sup', [_vm._v("249")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It has not been possible to identify elsewhere the second Neill Beaton and final signatory of the 1684 discharge. Although of the four Beatons who signed this discharge only Fergus is on record as a physician, it is likely that the other three were also medical men. The reason for their presence on Canna together was probably the ill-health of their employer, Donald MacDonald. He died, apparently on Canna, sometime between 23 September 1684 and 3 September 1685."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn250",
      "id": "rfn250"
    }
  }, [_c('sup', [_vm._v("250")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Two branches of the same family hailing from South Uist seem to be involved here. Thus Fergus and the second Neill spelt their surname "), _c('em', [_vm._v("Beatton")]), _vm._v(", while the first Neill and Donald wrote "), _c('em', [_vm._v("Beattone")]), _vm._v(". Indeed, if it were not for the different forenames, it would be difficult to distinguish between the signatures of the second pair, so similar in style are they. Clearly Fergus was head of the family by 1684 and probably by 1683. His predecessor, possibly his father, may have been the other Donald from South Uist, recorded as witnessing a sasine there in 1670,"), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn251",
      "id": "rfn251"
    }
  }, [_c('sup', [_vm._v("251")])]), _vm._v(" who in turn was doubtless the same as the Donald Beaton from Uist who, along with the first Neill Beaton of the 1684 discharge, signed the execution of letters of horning on 16 September 1682."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn252",
      "id": "rfn252"
    }
  }, [_c('sup', [_vm._v("252")])]), _vm._v(" Here he spelt his surname "), _c('em', [_vm._v("Beatton")]), _vm._v(" with Fearchar MacCulloch’s ‘B’, and moreover, like Fergus, wrote only the first two "), _c('a', {
    attrs: {
      "id": "page_43"
    }
  }), _vm._v("letters of his forename in his signature. Furthermore, he is likely to be Malcolm’s unnamed son mentioned in the document recording receipts of South Uist teinds which belongs to the decade 1660–70. His witness of the sasine in South Uist in 1670 would indicate that his father had died by that time and that he was now head of the family. He himself probably died sometime between 16 September 1682 and 8 August 1683 when Fergus first appears as a witness.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There follows the pedigree of the Beatons in South Uist from Fergus Fionn:")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Illustration",
      "src": "images/f0043-01.png"
    }
  })]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "sec8"
    }
  }), _vm._v("Beatons in Kintail (Pedigree VI)")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("This is the pedigree of Eachann or Hector, son of Neill Óg. There was a Hector, son of Neill Óg Beaton, on record in 1625 who was a physician and who could have lived beyond 1660. However, he was a member of the Beaton family of Culnaskea employed by the Munros of Foulis in Ross-shire. All the evidence suggests that they were related to the Beatons of Husabost and therefore of the mainland division of the Beaton kindred."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn253",
      "id": "rfn253"
    }
  }, [_c('sup', [_vm._v("253")])]), _vm._v(" It is not likely that Christopher Beaton would graft, either in error or deliberately, a Culnaskea Beaton pedigree on to his own genealogical scheme.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("However, as already noted, Christopher’s original plan may not have included this pedigree, for he preceded it with the fictional section of the Beaton ancestry, which would have made a neat conclusion to his collection of genealogies."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn254",
      "id": "rfn254"
    }
  }, [_c('sup', [_vm._v("254")])]), _vm._v(" It may be therefore that pedigree VI was that of a family "), _c('a', {
    attrs: {
      "id": "page_44"
    }
  }), _vm._v("who did not belong to the Clan Donald and MacLean ambit of the Western Isles with which Christopher himself was most familiar. The name "), _c('em', [_vm._v("Hector")]), _vm._v(" may be a clue as to their employers. It was very unusual among the Beatons, and the only other contemporary instance on record is Hector of the Culnaskea Beatons just mentioned, almost certainly a reflection of the fact that "), _c('em', [_vm._v("Hector")]), _vm._v(" was a common name among the Munros of Foulis. So it was too among their powerful neighbours to the west of them, the MacKenzies of Kintail, who, at the beginning of the seventeenth century, also gained possession of the island of Lewis. It was claimed in the concluding section to "), _c('em', [_vm._v("An Historical and Genealogical Account of the Bethunes of the Island of Sky")]), _vm._v(" that in the second half of the seventeenth century there was “a valiant little clan in Kintail, part of Seaforth’s country . . . who . . . professed themselves to be Bethunes”."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn255",
      "id": "rfn255"
    }
  }, [_c('sup', [_vm._v("255")])]), _vm._v(" It is clear that the author of the account had no certain evidence of their affiliations but it does suggest that the MacKenzies employed a family of Beaton physicians and it may be possible in the future to identify them in the surviving Seaforth records.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There follows the pedigree of these Beatons from Fergus Fionn:")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Illustration",
      "src": "images/f0044-01.png"
    }
  })]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "sec9"
    }
  }), _vm._v("Beatons of Kilelane")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Gaelic MS IV was written by and for Beatons, apparently from Islay, who were not only possible contemporary collateral relations of Fergus Fionn but also practising physicians. As already noted, the main text, a compendium of medical definitions, was written by Mael-Seachlainn mac Iollainn mhic an Leagha Ruaidh for “Niall mac Neill Meigbethadh .i. mo sesi”, ‘Neill, son of Neill MacBeth, namely, my companion’."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn256",
      "id": "rfn256"
    }
  }, [_c('sup', [_vm._v("256")])]), _vm._v(" Elsewhere in the manuscript, once in Gaelic and twice in Latin, a Neill Óg claimed ownership thereof."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn257",
      "id": "rfn257"
    }
  }, [_c('sup', [_vm._v("257")])]), _vm._v(" The first twenty-two folios contain the Vulgate "), _c('a', {
    attrs: {
      "id": "page_45"
    }
  }), _vm._v("version of Psalm 118 carefully written in Latin and ending with a colophon “Mise, Niall do graibne an bec sin”, ‘I, Neill, wrote that small portion’."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn258",
      "id": "rfn258"
    }
  }, [_c('sup', [_vm._v("258")])]), _vm._v(" This is likely to be Neill Óg’s father. The epithet "), _c('em', [_vm._v("óg")]), _vm._v(" often presupposes a father or grandfather of the same name and we can imagine Neill Óg, on the point of setting out to visit the medical school of his kinsmen, the MacLeays in distant Co. Sligo, being presented with this otherwise empty, remarkably small and therefore distinctive manuscript as a parting gift by his father. The psalm, which is put in the mouth of a young man, begins:")]), _vm._v(" "), _c('div', {
    staticClass: "move"
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("‘Blessed are those whose way is blameless, who walk in the law of the Lord’.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("Since Mael-Seachlainn was the principal scribe of another manuscript written in the year 1512,"), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn259",
      "id": "rfn259"
    }
  }, [_c('sup', [_vm._v("259")])]), _vm._v(" Neill Óg should probably be identified with "), _c('em', [_vm._v("Neill Óg Leich")]), _vm._v(" who, according to a crown rental of 1541, held the two and a half merklands of Kilelane in the parish of Kildalton, Islay."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn260",
      "id": "rfn260"
    }
  }, [_c('sup', [_vm._v("260")])]), _vm._v(" Kilelane, following on Glenegedale in the Kildalton section of the crown rental and the last place listed therein, is sited on the map in "), _c('em', [_vm._v("Origines Parochiales Scotiae")]), _vm._v(" west of Glenegedale and immediately to the east of the River Laggan, which was the boundary between Kildalton and the neighbouring parish of Kilarrow."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn261",
      "id": "rfn261"
    }
  }, [_c('sup', [_vm._v("261")])]), _vm._v(" Other than Neill Óg’s surname there is no indication here or elsewhere in the "), _c('em', [_vm._v("Exchequer Rolls")]), _vm._v(" of this period that he practised medicine there, but he is the only person so described in the parish of Kildalton, and the other two Islay parishes each possessed a physician in 1541, Fergus, grandson of Fergus Fionn, in Kilchoman"), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn262",
      "id": "rfn262"
    }
  }, [_c('sup', [_vm._v("262")])]), _vm._v(" and Neill MacMurchie, "), _c('em', [_vm._v("medicus")]), _vm._v(", in Kilarrow."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn263",
      "id": "rfn263"
    }
  }, [_c('sup', [_vm._v("263")])]), _vm._v(" Moreover, other Islay Beatons, Donald Mór, son of Fergus Fionn, and Gille-Coluim, a grandson, were apparently also using the surname "), _c('em', [_vm._v("Leich")]), _vm._v(" in 1541."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn264",
      "id": "rfn264"
    }
  }, [_c('sup', [_vm._v("264")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Although holding Kilelane of the crown in 1541, it is likely that Neill Óg and his family were employed by the Clan Donald of Islay. Four years later "), _c('a', {
    attrs: {
      "id": "page_46"
    }
  }), _vm._v("James MacDonald of Dunivaig and the Glens, in return for services rendered to the crown during the minority of Mary, Queen of Scots, especially in opposing her English enemies, had lands in Scotland erected into the barony of Bar in North Kintyre. Those listed in Islay included the two and a half merklands of Kilelane."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn265",
      "id": "rfn265"
    }
  }, [_c('sup', [_vm._v("265")])])]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "sec10"
    }
  }), _vm._v("Beatons in Colonsay")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The Irish Franciscan mission to Scotland made a list of converts to Roman Catholicism on Colonsay c. 1625 in which were recorded side by side the names of "), _c('em', [_vm._v("Jacobus Biatadh")]), _vm._v(" and "), _c('em', [_vm._v("Edmundus Biatadh.")]), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn266",
      "id": "rfn266"
    }
  }, [_c('sup', [_vm._v("266")])]), _vm._v(" "), _c('em', [_vm._v("Mac")]), _vm._v(" of the patronymic or surname was regularly omitted in this and similar lists from other islands, and "), _c('em', [_vm._v("Biatadh")]), _vm._v(" looks like a form of "), _c('em', [_vm._v("MacBheathadh. Edmundus")]), _vm._v(" became the Latin equivalent of its Gaelic derivative "), _c('em', [_vm._v("Eamonn")]), _vm._v(","), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn267",
      "id": "rfn267"
    }
  }, [_c('sup', [_vm._v("267")])]), _vm._v(" common in Ireland but rare in Scotland. It was possibly he who signed a Gaelic medical manuscript now in John Rylands University Library of Manchester as “Edmond MacBeth”."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn268",
      "id": "rfn268"
    }
  }, [_c('sup', [_vm._v("268")])]), _vm._v(" The signature is in a Roman hand, but presumably dating to before c.1650, when most members of the kindred were using a form of the surname "), _c('em', [_vm._v("Beaton")]), _vm._v(" in non-Gaelic contexts."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn269",
      "id": "rfn269"
    }
  }, [_c('sup', [_vm._v("269")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The manuscript was on the nearby island of Islay early in the second half of the previous century. At one point, the owner, without unfortunately identifying himself, named five patients, four men and one woman, whom he had treated ‘between "), _c('em', [_vm._v("an Learga")]), _vm._v(" and "), _c('em', [_vm._v("an Ogha")]), _vm._v("’."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn270",
      "id": "rfn270"
    }
  }, [_c('sup', [_vm._v("270")])]), _vm._v(" A description of Islay written c. 1630 states that “it is divydit in thrie pairts. The Largki and the hoo is one pairt”."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn271",
      "id": "rfn271"
    }
  }, [_c('sup', [_vm._v("271")])]), _vm._v(" The tripartite division of Islay was already of long standing, and one of these was the parish of Kildalton,"), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn272",
      "id": "rfn272"
    }
  }, [_c('sup', [_vm._v("272")])]), _vm._v(" the southernmost district of which is "), _c('em', [_vm._v("an Ogha")]), _vm._v(" or the Mull of Oa. The description goes on to "), _c('a', {
    attrs: {
      "id": "page_47"
    }
  }), _vm._v("say that the castle of Dunivaig “lyes on the eastsyd of that pairt called the Largki”. "), _c('em', [_vm._v("An Learga")]), _vm._v(" is the northern and larger of the two districts into which the parish was divided.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Elsewhere in the manuscript the same scribe recorded at length the pedigree of Gill-easbuig MacDonald of Dunivaig and the Glens."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn273",
      "id": "rfn273"
    }
  }, [_c('sup', [_vm._v("273")])]), _vm._v(" Gilleasbuig succeeded his father, James, on the latter’s death sometime between October 1565 when, according to an account entered in the Exchequer Rolls, he was still alive, and 18 January 1566, the date of a crown gift of the marriage of Gill-easbuig, son and heir of the deceased James, to his mother, Agnes Campbell."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn274",
      "id": "rfn274"
    }
  }, [_c('sup', [_vm._v("274")])]), _vm._v(" The barony of Bar had already been granted to Gill-easbuig in 1564, reserving a life-rent to his father."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn275",
      "id": "rfn275"
    }
  }, [_c('sup', [_vm._v("275")])]), _vm._v(" However, Gilleasbuig did not long survive the latter, for his brother, Angus, received sasine of the barony of Bar on 29 December 1567."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn276",
      "id": "rfn276"
    }
  }, [_c('sup', [_vm._v("276")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The compiler of the list of patients and Gill-easbuig’s pedigree was likely to have been a Beaton writing in the parish of Kildalton sometime between c.1565 and c.1567. But he was probably a visiting physician rather than a member of the resident family of Kilelane. This is suggested first of all by the wording of the statement introducing the list of patients. Indeed, why make such a list at all, if he was resident? Secondly, the patients seem to be identified by surname rather than patronymic, which is not what one would expect from a physician of the period permanently domiciled in the parish.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The first patient was named Gille-Críost mac Acairrcigh. The forename "), _c('em', [_vm._v("Acairrceach")]), _vm._v(" seems to appear again in the Kildalton section of an Islay rental dated 1643 wherein "), _c('em', [_vm._v("Clagincarroche")]), _vm._v(" was set to "), _c('em', [_vm._v("Neill mc chargie")]), _vm._v(" among others."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn277",
      "id": "rfn277"
    }
  }, [_c('sup', [_vm._v("277")])]), _vm._v(" "), _c('em', [_vm._v("Acairrceach")]), _vm._v(" is not otherwise on record in Islay, and this identification is in keeping with the north-south direction in which the patients were apparently listed, for the lands of Clagincarroch presumably bordered present-day Claggain Bay about five miles north of Dunivaig. The apparent rarity of "), _c('em', [_vm._v("Acairrceach")]), _vm._v(" suggests that here it is part of a surname rather than a patronymic. It may be that the modern Galloway surname "), _c('em', [_vm._v("MacCargo")]), _vm._v(" is an Anglicised form thereof."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn278",
      "id": "rfn278"
    }
  }, [_c('sup', [_vm._v("278")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There are good reasons for regarding all the names in the list in the same light. The next is Gille-naoimh Buidhe mac Diarmait. "), _c('em', [_vm._v("Dairmait")]), _vm._v(", of course, "), _c('a', {
    attrs: {
      "id": "page_48"
    }
  }), _vm._v("continued in use as a forename in Scotland but not, apparently, in Islay, at least by the seventeenth century, for, although it appears three times in the rental for 1643, it is in each case preceded by "), _c('em', [_vm._v("mac")]), _vm._v("."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn279",
      "id": "rfn279"
    }
  }, [_c('sup', [_vm._v("279")])]), _vm._v(" The one woman in the list is simply called Nic Ghille-Comhaill. "), _c('em', [_vm._v("Gille-Comhaill")]), _vm._v(" is for "), _c('em', [_vm._v("Gille-Comgaill")]), _vm._v(", ‘devotee of Comgall’, the name of a number of important Celtic Church saints. "), _c('em', [_vm._v("Gille-Comgaill")]), _vm._v(" is another rare forename in this period, not otherwise recorded in Islay, unless it was later confused with "), _c('em', [_vm._v("Gille-Conaill")]), _vm._v(", ‘devotee of Conall’, forming part of the surname "), _c('em', [_vm._v("Macilchonel")]), _vm._v(" in a rental for 1733."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn280",
      "id": "rfn280"
    }
  }, [_c('sup', [_vm._v("280")])]), _vm._v(" Likewise "), _c('em', [_vm._v("Anagal")]), _vm._v(" in Eoin mac Anagail, fourth on the list, is not on record as a forename in Scotland later than the thirteenth century."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn281",
      "id": "rfn281"
    }
  }, [_c('sup', [_vm._v("281")])]), _vm._v(" However, "), _c('em', [_vm._v("MacAnagail")]), _vm._v(" still survives as a surname, if it is the same as the present-day Anglicised "), _c('em', [_vm._v("MacGonigle")]), _vm._v("."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn282",
      "id": "rfn282"
    }
  }, [_c('sup', [_vm._v("282")])]), _vm._v(" The fifth and last name is only partly legible but the final forename begins with an ‘a’ and the small space remaining suggests that it was some form of "), _c('em', [_vm._v("Aodh")]), _vm._v(" which is present in "), _c('em', [_vm._v("MacAoidh")]), _vm._v(" or "), _c('em', [_vm._v("MacKay")]), _vm._v(", one of the commonest surnames in Islay during the late medieval period. If this is correct, the patient was identified in the list as “mac Eoghain Mhic Aoidh”, ‘son of Eoghan MacKay’.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Although a visitor to Kildalton at the time of writing, the compiler of the list may have been related to and/or trained by the Beatons of Kilelane, for there are stylistic similarities between his handwriting and those of the two Neills in MS IV, notably a distinctive form of the letter ‘g’, while he and Neill Óg consistently wrote the letter ‘d’ with a long shaft. If he was a member of the Beaton family on Colonsay, as seems likely, his interest in Gill-easbuig MacDonald’s ancestry would be explained by the inclusion of that island in the barony of Bar. It remained in the possession of the MacDonalds of Dunivaig until the death of the famous Colla Ciotach in 1647."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn283",
      "id": "rfn283"
    }
  }, [_c('sup', [_vm._v("283")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Finally, Edmund Beaton who held lands in the parish of Kilchoman, Islay, in 1686 doubtless belonged to one or other of these families."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn284",
      "id": "rfn284"
    }
  }, [_c('sup', [_vm._v("284")])]), _vm._v(" It was perhaps in tribute to them that Mr John Beaton, minister of Kilninian (d. 1714), named the oldest of his three sons Eamonn or Edmund."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn285",
      "id": "rfn285"
    }
  }, [_c('sup', [_vm._v("285")])])]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "page_49"
    }
  }), _c('a', {
    attrs: {
      "id": "sec11"
    }
  }), _vm._v("Beatons in Dervaig")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Other Beatons besides those of Pennycross were employed as physicians by the MacLeans of Duart. The earliest on record is James Beaton, entitled "), _c('em', [_vm._v("an t-Ollamh Muileach")]), _vm._v(", who attended Alexander Fraser of Lovat on his deathbed in 1558, according to Mr James Fraser, minister in the parish of Kirkhill from 1662 to 1709."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn286",
      "id": "rfn286"
    }
  }, [_c('sup', [_vm._v("286")])]), _vm._v(" Not until 1572 was Andrew Beaton, the founder of the Pennycross family, granted the lands thereof along with the office of "), _c('em', [_vm._v("an t-Ollamh Muileach")]), _vm._v("."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn287",
      "id": "rfn287"
    }
  }, [_c('sup', [_vm._v("287")])]), _vm._v(" It may be that the nuns of Iona, Fionnghuala and Mariota "), _c('em', [_vm._v("Macinolly, mac an ollaimh")]), _vm._v(", doubtless sisters, who died sometime between 1500 and 1560 and whose graveslab is still in the nunnery, were kinswomen of James Beaton."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn288",
      "id": "rfn288"
    }
  }, [_c('sup', [_vm._v("288")])]), _vm._v(" It was also probably he who signed in a sixteenth century hand MS III as "), _c('em', [_vm._v("Semus mac an ollaimh")]), _vm._v(" on folio 83r, while at the end of the manuscript ownership was claimed for him by another James Beaton, likely to be a later member of the same family."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn289",
      "id": "rfn289"
    }
  }, [_c('sup', [_vm._v("289")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The second James Beaton, who may himself have been "), _c('em', [_vm._v("an t-Ollamh Muileach")]), _vm._v(" for a time in the first half of the seventeenth century, is identified in this instance by his distinctive Gaelic script. It appears again along with his English signature in MSS XXIX and XXXIII"), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn290",
      "id": "rfn290"
    }
  }, [_c('sup', [_vm._v("290")])]), _vm._v(" and ownership of MS XXIX was claimed for him."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn291",
      "id": "rfn291"
    }
  }, [_c('sup', [_vm._v("291")])]), _vm._v(" He also assisted the main scribe of Adv. 18. 2. 11, a copy of Bernard Gordon’s "), _c('em', [_vm._v("Lilium Medicinae")]), _vm._v(", transcribing a considerable portion of this work at the point at which it was stated that the manuscript was being written in the month of October, 1621, at Duart, Mull."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn292",
      "id": "rfn292"
    }
  }, [_c('sup', [_vm._v("292")])]), _vm._v(" These three manuscripts plus MS III were to be in the possession of the Pennycross family, while the two sections of MS XXXIII had already been bound together by Malcolm Beaton of Pennycross (1582– 1603)."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn293",
      "id": "rfn293"
    }
  }, [_c('sup', [_vm._v("293")])]), _vm._v(" It may be that James introduced MS III and XXIX into the Pennycross collection. Just about this time the known dates of the Pennycross family would indicate that they were unable to find a suitable candidate for the position of "), _c('em', [_vm._v("an t-Ollamh Muileach.")]), _vm._v(" Thus, Malcolm is last heard of in 1603, and although he is said to have been succeeded in Pennycross by his older son, Donald, the latter, already on record in 1582, may not have survived him long. On the other hand, it is known that Malcolm’s younger son, John, was only born in 1594, and he is not "), _c('a', {
    attrs: {
      "id": "page_50"
    }
  }), _vm._v("recorded as servitor to MacLean of Duart until 1633. Finally, Donald’s son, Fergus, also presumably too young and inexperienced at this point, did not succeed to Pennycross until his uncle’s death in 1657."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn294",
      "id": "rfn294"
    }
  }, [_c('sup', [_vm._v("294")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The following verse was written into MS XXIX:")]), _vm._v(" "), _c('div', {
    staticClass: "move"
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("“Johne O Morisone is my name")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("and for to shaw I thinke no shame")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("James Bettonne is my freinde”."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn295",
      "id": "rfn295"
    }
  }, [_c('sup', [_vm._v("295")])])])]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("Alongside and also in English, James Beaton replied in like vein. According to himself he was then “at the Larne”, probably Larne, Co. Antrim. John O Morisone is almost certainly Eoin Óg Ó Muirgheasáin, member of a professional family of poets employed by the MacLeans of Duart and by the MacLeods of Dunvegan in the seventeenth century."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn296",
      "id": "rfn296"
    }
  }, [_c('sup', [_vm._v("296")])]), _vm._v(" He composed an elegy on the death of Ruairi Mór MacLeod in 1626."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn297",
      "id": "rfn297"
    }
  }, [_c('sup', [_vm._v("297")])]), _vm._v(" Elsewhere in MS XXIX and at the same time, as the handwriting and ink show, Eoin Óg addressed “the Right reverend father in God, John, by the Devine Providence, Lord Bishopp of Derry”."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn298",
      "id": "rfn298"
    }
  }, [_c('sup', [_vm._v("298")])]), _vm._v(" This can only be John Tanner, Bishop of Derry from 1613 until his death in 1615."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn299",
      "id": "rfn299"
    }
  }, [_c('sup', [_vm._v("299")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Immediately below the words addressed to Eoin Óg already mentioned and in similar ink, James Beaton wrote on 16 September, presumably later in the same year, that he was “at Artw”. If this was meant to represent the common placename element "), _c('em', [_vm._v("ard")]), _vm._v(", there is a district of that name in nearby Co. Down and another place so-called near Enniskillen in Co. Fermanagh."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn300",
      "id": "rfn300"
    }
  }, [_c('sup', [_vm._v("300")])]), _vm._v(" However, it is equally common in Scotland and "), _c('em', [_vm._v("Arde")]), _vm._v(" may have been written for Ardchattan in 1570."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn301",
      "id": "rfn301"
    }
  }, [_c('sup', [_vm._v("301")])]), _vm._v(" Wherever the place, James was there, as he put it, “betwixt Laucland mc donald mc nell and n . . .” The statement is now incomplete because of a tear in the manuscript at this point. Much later Neill MacMhuirich, poet and scribe to Clan Ranald who "), _c('a', {
    attrs: {
      "id": "page_51"
    }
  }), _vm._v("died c.1726,"), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn302",
      "id": "rfn302"
    }
  }, [_c('sup', [_vm._v("302")])]), _vm._v(" presumably recognising Lachlan as his ancestor, wrote above James’ note “the man is blest” and below it his signature. In 1800 Neill’s great grandson, also Lachlan, recited eight generations of his ancestors, the final two steps being Lachlan, son of Donald."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn303",
      "id": "rfn303"
    }
  }, [_c('sup', [_vm._v("303")])]), _vm._v(" The ninth generation must therefore be the earlier Lachlan’s grandfather, Neill, as in MS XXIX. Lachlan’s son, according to the pedigree of 1800, was Neill Mór who composed the well-known poem describing a feast at Dunvegan during the chiefship of Ruairi Mór MacLeod (d. 1626)."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn304",
      "id": "rfn304"
    }
  }, [_c('sup', [_vm._v("304")])]), _vm._v(" The occasion of this feast is usually taken to be the marriage of Iain Muideartach to Mór, daughter of Ruairi Mór, in 1613, and Neill Mór is thought to have been head of his family by this time. However, it seems that his father, Lachlan, was still alive in 1613, and it is possible that Neill Mór was the other person (whose name began with ‘n’) present when James Beaton wrote his note, apparently sometime during the period 1613–15.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At the end of MS III in secretary hand is written “. . . for the name of Duncane Steuart” and immediately below in James’ handwriting ‘Alan Stewart, Alan, son of Duncan Óg, wrote this for me in the book of "), _c('em', [_vm._v("Semus mac an ollaimh")]), _vm._v("’,"), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn305",
      "id": "rfn305"
    }
  }, [_c('sup', [_vm._v("305")])]), _vm._v(" copying Semus’ name exactly as it had appeared in Semus’ signature earlier in the manuscript."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn306",
      "id": "rfn306"
    }
  }, [_c('sup', [_vm._v("306")])]), _vm._v(" At the time of writing, James was probably attending the Stewarts of Appin, as did an earlier "), _c('em', [_vm._v("Ollamh Muileach")]), _vm._v(", Malcolm Beaton of Pennycross, c.1595."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn307",
      "id": "rfn307"
    }
  }, [_c('sup', [_vm._v("307")])]), _vm._v(" Duncan Mór, chief of the Appin Stewarts, on record from 1620 until his death in 1685, had a younger brother, Alan. Their father was Duncan, son of Duncan, and therefore likely to be named "), _c('em', [_vm._v("Donnchadh Óg")]), _vm._v(" in Gaelic as above."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn308",
      "id": "rfn308"
    }
  }, [_c('sup', [_vm._v("308")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Finally, if the appearance of John Beaton of Pennycross as servitor to MacLean of Duart in 1633 indicates that he had succeeded James as "), _c('em', [_vm._v("an t-Ollamh Muileach")]), _vm._v(", it was not too long before, for John’s own son, Neill, had assisted James in writing MS 2076 and Neill, whose father was born in 1594, cannot have been much more than twenty years of age in 1633."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn309",
      "id": "rfn309"
    }
  }, [_c('sup', [_vm._v("309")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The two James were likely to have been members of a family of Beaton physicians, one of whose characteristic personal names was "), _c('em', [_vm._v("James")]), _vm._v(", who were located in Mull and employed by the MacLeans of Duart from at least "), _c('a', {
    attrs: {
      "id": "page_52"
    }
  }), _vm._v("as early as the middle of the sixteenth century. A third James Beaton was still practising medicine in Mull in 1771. The registrar of the combined parish of Kilninian and Kilmore noted on 5 February that James was paid in part “for curing Jean McLauchlane” and paid in full twelve days later."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn310",
      "id": "rfn310"
    }
  }, [_c('sup', [_vm._v("310")])]), _vm._v(" There are yet other Beatons on record in Mull in the seventeenth and eighteenth centuries who cannot be fitted into the Pennycross family. In 1656 the Synod of Argyll appointed the Presbytery of Lorn to persuade Ruairi or Roderick Beaton in Mull “to adher to his married wife”."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn311",
      "id": "rfn311"
    }
  }, [_c('sup', [_vm._v("311")])]), _vm._v(" A second Roderick Beaton and suspected Jacobite was captured on board ship sailing from Mull in 1746 and sent as a prisoner to Edinburgh."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn312",
      "id": "rfn312"
    }
  }, [_c('sup', [_vm._v("312")])]), _vm._v(" Enquiring about a third Roderick Beaton and his nephew, Malcolm, whom he had recently met in Dervaig, which is in the parish of Kilninian and Kilmore, T. S. Muir received a communication dated 12 August 1856 from Miss MacLean of Pennycross informing him that “your Dervaigh acquaintances are more remote than the Beatons here”, that is, than contemporary descendants of the Beatons of Pennycross."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn313",
      "id": "rfn313"
    }
  }, [_c('sup', [_vm._v("313")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Was "), _c('em', [_vm._v("Ruairi")]), _vm._v(" or "), _c('em', [_vm._v("Roderick")]), _vm._v(" another of the characteristic names of the second Beaton family on Mull and was Dervaig their original home? It is worth noting that in the same parish, at Aros Castle which belonged to MacLean of Duart for much of the sixteenth and seventeenth centuries, tradition records an unidentified Beaton doctor effecting a remarkable cure to the discomfiture of prominent medical rivals."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn314",
      "id": "rfn314"
    }
  }, [_c('sup', [_vm._v("314")])]), _vm._v(" Nor need it surprise us that the MacLeans employed two Beaton medical families. The MacDonalds of Sleat employed at least three in the seventeenth century and it will be seen that the MacDonalds of Clan Ranald did likewise. Mull is an extensive island and Pennycross on the southern shore of Loch Scridain and Dervaig in the north-west of the island are more or less at opposite ends. Moreover, the use of the adjective "), _c('em', [_vm._v("ard")]), _vm._v(", ‘chief’ or ‘principal’, before "), _c('em', [_vm._v("ollamhnachd")]), _vm._v(" in the grant of that office made to Andrew Beaton in 1572 implies that there were other physicians in MacLean territories."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn315",
      "id": "rfn315"
    }
  }, [_c('sup', [_vm._v("315")])]), _vm._v(" The second Beaton family was in possession of the office before the Beatons of Pennycross made their appearance and for a time in the first half of the seventeenth century they may have succeeded in regaining possession of it. Again this would be in keeping with the kin-based rules of succession. Doubtless they were of the island division of Beatons but, as Miss MacLean’s statement may have "), _c('a', {
    attrs: {
      "id": "page_53"
    }
  }), _vm._v("been intended to imply, not descended from Fergus Fionn, hence their omission from the Laing MS pedigrees.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The "), _c('em', [_vm._v("iorram")]), _vm._v(" to James Beaton, great-grandson of John Beaton of Pennycross, is in three parts. The first and third are in praise of James but the subject of the middle part is the "), _c('em', [_vm._v("Ollamh Muileach")]), _vm._v(" who was supposed to be James’ ancestor and it goes on to refer to him as the Beaton doctor who was called to cure the king of Scots lying on his deathbed, having been given up for lost by all his other physicians."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn316",
      "id": "rfn316"
    }
  }, [_c('sup', [_vm._v("316")])]), _vm._v(" If there is any truth in this story, which appears in more detail in an accompanying footnote and elsewhere,"), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn317",
      "id": "rfn317"
    }
  }, [_c('sup', [_vm._v("317")])]), _vm._v(" it should probably not have been associated with John Beaton who died in 1657 and who was only nine years old when James VI removed to London in 1603. On the other hand, on the only occasion that we see James Beaton, "), _c('em', [_vm._v("an t-Ollamh Muileach")]), _vm._v(", who flourished in the middle of the sixteenth century, in action, he was furth of Mull attending an important noble in the east of Scotland."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn318",
      "id": "rfn318"
    }
  }, [_c('sup', [_vm._v("318")])]), _vm._v(" The name "), _c('em', [_vm._v("James")]), _vm._v(", too, is characteristic of the Stewarts and may itself be an indication of a continuing connection with the Stewart line of kings. The spread of this name among other Beaton families in the late sixteenth and seventeenth centuries would then be a tribute to the medical skill and prestige of this family.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Irish evidence further suggests first that the Beatons in Dervaig were of long standing by the sixteenth century and second that the Beatons of Kilelane, Colonsay and Dervaig were a closely related group of families within the island division of the kindred comparable to those later descended from Fergus Fionn. As early as 1473 Roderick MacBeth, "), _c('em', [_vm._v("medicus")]), _vm._v(", was granted lands in Co. Cork by the Lord of Kinsale, “unacum dignitate ac libertate medicinale per totum dominium meum ubicunque se extendit”."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn319",
      "id": "rfn319"
    }
  }, [_c('sup', [_vm._v("319")])]), _vm._v(" If the sixteenth century family with the obviously Anglicised surname of "), _c('em', [_vm._v("Baye")]), _vm._v(" or "), _c('em', [_vm._v("Bayes")]), _vm._v(", who were physicians and later merchants in Kinsale, were Roderick’s descendants, it is worth noting that the forenames "), _c('em', [_vm._v("James")]), _vm._v(" and "), _c('em', [_vm._v("Edmund")]), _vm._v(" were in use among them."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn320",
      "id": "rfn320"
    }
  }, [_c('sup', [_vm._v("320")])]), _vm._v(" There was another family of MacBeths practising medicine in Co. Mayo in the "), _c('a', {
    attrs: {
      "id": "page_54"
    }
  }), _vm._v("sixteenth century"), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn321",
      "id": "rfn321"
    }
  }, [_c('sup', [_vm._v("321")])]), _vm._v(" and one of their number was Hugh, son of James, "), _c('em', [_vm._v("chirurgeon")]), _vm._v(", who received a pardon from the English authorities in 1593."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn322",
      "id": "rfn322"
    }
  }, [_c('sup', [_vm._v("322")])]), _vm._v(" In 1591 so too did Gille-Coluim MacBeth, also from Co. Mayo."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn323",
      "id": "rfn323"
    }
  }, [_c('sup', [_vm._v("323")])]), _vm._v(" It may be that Iollann MacBeth who attended the Ó Conchobhair medical school at Aghamacart in 1596 was yet another member of this family who had been given the rare but characteristic forename of the MacLeay physicians in neighbouring Co. Sligo in recognition of their kinship."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn324",
      "id": "rfn324"
    }
  }, [_c('sup', [_vm._v("324")])])]), _vm._v(" "), _c('div', {
    staticClass: "page-break"
  }, [_c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn29",
      "id": "fn29"
    }
  }, [_vm._v("29")]), _vm._v(" "), _c('em', [_vm._v("Infra")]), _vm._v(", p. 28.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn30",
      "id": "fn30"
    }
  }, [_vm._v("30")]), _vm._v(" "), _c('em', [_vm._v("Infra")]), _vm._v(", pp. 22, 43.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn31",
      "id": "fn31"
    }
  }, [_vm._v("31")]), _vm._v(" "), _c('em', [_vm._v("Infra")]), _vm._v(", p. 12.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn32",
      "id": "fn32"
    }
  }, [_vm._v("32")]), _vm._v("    Add. 15,582, f.61r, a12. He writes the year date in Arabic figures immediately preceding this passage, again at the end of col. a. and once more in col. b. It seems likely therefore that when he wrote the date out in full in the body of the text as “mile bliadhna 7 cuig céad 7 ceithre fithid 7 a h-ocht deg”, that is, ‘1598’, that he was being careless, as he was with steps in his own pedigree both before and after Fergus Fionn ("), _c('em', [_vm._v("infra")]), _vm._v(", p. 13).")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn33",
      "id": "fn33"
    }
  }, [_vm._v("33")]), _vm._v("    The top part of the ‘dh’ of the deleted "), _c('em', [_vm._v("Aodha")]), _vm._v(" is still visible.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn34",
      "id": "fn34"
    }
  }, [_vm._v("34")]), _vm._v("    Just possibly an irregular spelling of "), _c('em', [_vm._v("leagha")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn35",
      "id": "fn35"
    }
  }, [_vm._v("35")]), _vm._v("    Adv. 72. 1. 4., f. 100r.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn36",
      "id": "fn36"
    }
  }, [_vm._v("36")]), _vm._v("    Walsh, "), _c('em', [_vm._v("Irish Men")]), _vm._v(", pp. 206–18.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn37",
      "id": "fn37"
    }
  }, [_vm._v("37")]), _vm._v("    Adv. 73. 1. 22, f. 122r.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn38",
      "id": "fn38"
    }
  }, [_vm._v("38")]), _vm._v("    See MacNiocaill, G., "), _c('em', [_vm._v("Ireland before the Vikings")]), _vm._v(", 1972; Ó Corráin, D., "), _c('em', [_vm._v("Ireland before the Normans")]), _vm._v(", 1972.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn39",
      "id": "fn39"
    }
  }, [_vm._v("39")]), _vm._v("    O’Brien, M. A., "), _c('em', [_vm._v("Corpus Genealogiarum Hiberniae")]), _vm._v(", 1962, pp. 178–9.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn40",
      "id": "fn40"
    }
  }, [_vm._v("40")]), _vm._v("    In choosing this pedigree, the genealogist ignored three others actually containing the name "), _c('em', [_vm._v("Mac-bethadh")]), _vm._v(". But two were of Munster provenance ("), _c('em', [_vm._v("ibid")]), _vm._v("., pp. 240, 254) while the third was that of MacBeth, King of Scots (1040–57) ("), _c('em', [_vm._v("ibid.,")]), _vm._v(" p. 330), and any attempt to equate the eponymous Beaton ancestor with him would not have been acceptable, if only because the Beatons more recent Irish origins were too well known.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn41",
      "id": "fn41"
    }
  }, [_vm._v("41")]), _vm._v("    Christopher underdotted the ‘a’ "), _c('em', [_vm._v("of goradh")]), _vm._v(" intending to replace it with the ‘i’ which he wrote above it. This change is orthographical only.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn42",
      "id": "fn42"
    }
  }, [_vm._v("42")]), _vm._v("    Walsh, "), _c('em', [_vm._v("Irish Men")]), _vm._v(", pp. 206–18.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn43",
      "id": "fn43"
    }
  }, [_vm._v("43")]), _vm._v("    A faint down-stroke from the first ‘a’ of "), _c('em', [_vm._v("achadh")]), _vm._v(" in the Laing MS should be ignored. This, together with the fact that lenition of the following ‘c’ is not indicated, led Professor MacKinnon to read ‘arcadh’ at this point (‘The Genealogy of the MacBeths or Beatons of Islay and Mull’, p. 142). For other references to this placename, see Hogan, E., "), _c('em', [_vm._v("Onomasticon Goedelicum")]), _vm._v(", 1910, p. 8.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn44",
      "id": "fn44"
    }
  }, [_vm._v("44")]), _vm._v("    See also Reeves, W., "), _c('em', [_vm._v("Acts of Archbishop Colton in his Metropolitan Visitation of the Diocese of Derry")]), _vm._v(", 1850, pp. 74–5, n.2.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn45",
      "id": "fn45"
    }
  }, [_vm._v("45")]), _vm._v("    Steer and Bannerman, "), _c('em', [_vm._v("Monumental Sculpture")]), _vm._v(", p. 107, n.9.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn46",
      "id": "fn46"
    }
  }, [_vm._v("46")]), _vm._v("    MacDonald, "), _c('em', [_vm._v("Clan Donald")]), _vm._v(", i, p. 570. She remains unnamed in the ‘Book of Clan Ranald’ ("), _c('em', [_vm._v("Clanranald Bk")]), _vm._v("., p. 158) but is called Margaret in the ‘History of the MacDonalds’ (MacDonald, "), _c('em', [_vm._v("History")]), _vm._v(", p. 20).")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn47",
      "id": "fn47"
    }
  }, [_vm._v("47")]), _vm._v(" "), _c('em', [_vm._v("Rot. Scot")]), _vm._v("., i, p. 534b.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn48",
      "id": "fn48"
    }
  }, [_vm._v("48")]), _vm._v("    MacDonald, "), _c('em', [_vm._v("History")]), _vm._v(", p. 20.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn49",
      "id": "fn49"
    }
  }, [_vm._v("49")]), _vm._v("    Matheson, W., ‘Traditions of the MacKenzies’, pp. 203, 208.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn50",
      "id": "fn50"
    }
  }, [_vm._v("50")]), _vm._v("    MacDonald, "), _c('em', [_vm._v("History")]), _vm._v(", p. 20. ‘The Book of Clan Ranald’ ("), _c('em', [_vm._v("Clanranald Bk")]), _vm._v("., p. 158) describes it as an ‘unusual retinue from Ireland . . . from whom sprang twenty-four families in Scotland’. Their descendants are still known as “tochradh nighean a’ Chathanaich”, ‘the dowry of Ó Cathán’s daughter’ (MacDonald, "), _c('em', [_vm._v("Clan Donald")]), _vm._v(", i, p. 100).")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn51",
      "id": "fn51"
    }
  }, [_vm._v("51")]), _vm._v(" "), _c('em', [_vm._v("RMS")]), _vm._v(", i (1306–1424), no. 333; App. I, no. 75; App. II, no. 446.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn52",
      "id": "fn52"
    }
  }, [_vm._v("52")]), _vm._v("    Barrow, G. W. S., "), _c('em', [_vm._v("Robert Bruce")]), _vm._v(", 1965, pp. 25, 38, 77, 79; "), _c('em', [_vm._v("Robert the Bruce and the Scottish Identity")]), _vm._v(", Saltire Pamphlets, New Series iv, 1984, pp. 15–17.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn53",
      "id": "fn53"
    }
  }, [_vm._v("53")]), _vm._v(" "), _c('em', [_vm._v("Infra")]), _vm._v(", p. 59.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn54",
      "id": "fn54"
    }
  }, [_vm._v("54")]), _vm._v("    Watson, W. J., "), _c('em', [_vm._v("Rosg Gaidhlig")]), _vm._v(", 1929, pp. 182–3.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn55",
      "id": "fn55"
    }
  }, [_vm._v("55")]), _vm._v("    MacKinnon, D., ‘The Genealogy of the MacBeths or Beatons of Islay and Mull’, p. 148.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn56",
      "id": "fn56"
    }
  }, [_vm._v("56")]), _vm._v(" "), _c('em', [_vm._v("Infra")]), _vm._v(", pp. 12–13.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn57",
      "id": "fn57"
    }
  }, [_vm._v("57")]), _vm._v("    McGurk, F., "), _c('em', [_vm._v("Calendar of Papal Letters to Scotland of Benedict XIII of Avignon")]), _vm._v(", 1394–1419, SHS, 1976, p. 173; Watt, "), _c('em', [_vm._v("Fasti")]), _vm._v(", p. 210.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn58",
      "id": "fn58"
    }
  }, [_vm._v("58")]), _vm._v(" "), _c('em', [_vm._v("Supra")]), _vm._v(", p. 7.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn59",
      "id": "fn59"
    }
  }, [_vm._v("59")]), _vm._v(" "), _c('em', [_vm._v("RSS")]), _vm._v(", ii (1529-42), nos. 1671, 4201. Also "), _c('em', [_vm._v("Ylane Oyrsay")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn60",
      "id": "fn60"
    }
  }, [_vm._v("60")]), _vm._v("    OS, 1 in.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn61",
      "id": "fn61"
    }
  }, [_vm._v("61")]), _vm._v(" "), _c('em', [_vm._v("RMS")]), _vm._v(", vii (1609–20), no. 109.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn62",
      "id": "fn62"
    }
  }, [_vm._v("62")]), _vm._v(" "), _c('em', [_vm._v("Infra")]), _vm._v(", pp. 58, 63.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn63",
      "id": "fn63"
    }
  }, [_vm._v("63")]), _vm._v(" "), _c('em', [_vm._v("ER")]), _vm._v(", xii (1502–07), p. 709.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn64",
      "id": "fn64"
    }
  }, [_vm._v("64")]), _vm._v(" "), _c('em', [_vm._v("ER")]), _vm._v(", xvii (1537–42), pp. 620, 640.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn65",
      "id": "fn65"
    }
  }, [_vm._v("65")]), _vm._v(" "), _c('em', [_vm._v("Ibid")]), _vm._v("., p. 555, “Fergusius Aldowy medicus”.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn66",
      "id": "fn66"
    }
  }, [_vm._v("66")]), _vm._v(" "), _c('em', [_vm._v("Ibid")]), _vm._v("., p. 630.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn67",
      "id": "fn67"
    }
  }, [_vm._v("67")]), _vm._v(" "), _c('em', [_vm._v("Infra")]), _vm._v(", p. 26.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn68",
      "id": "fn68"
    }
  }, [_vm._v("68")]), _vm._v(" "), _c('em', [_vm._v("ER")]), _vm._v(", xvii (1537–42), pp. 619, 639.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn69",
      "id": "fn69"
    }
  }, [_vm._v("69")]), _vm._v("    Elsewhere I suggested that Gille-Coluim "), _c('em', [_vm._v("mac an ollaimh")]), _vm._v(", court poet to the Lords of the Isles, was a Beaton, on the assumption that he was the same as Gille-Coluim "), _c('em', [_vm._v("Cléireach")]), _vm._v(" (‘The Lordship of the Isles’, in "), _c('em', [_vm._v("Scottish Society in the Fifteenth Century")]), _vm._v(", ed. Brown, J. M., 1977, p. 235). However, one of the three poems ascribed to him in the "), _c('em', [_vm._v("Book of the Dean of Lismore")]), _vm._v(" ("), _c('em', [_vm._v("BDL")]), _vm._v(", pp. 82–8) is a lament for Angus Óg MacDonald killed in the year 1490. The known dates of Gille-Coluim "), _c('em', [_vm._v("Cléireach")]), _vm._v(" and of the other grandsons of Fergus Fionn make it unlikely that he was an adult in 1490. Gille-Coluim "), _c('em', [_vm._v("mac an ollaimh")]), _vm._v(" was probably a member of the MacMhuirich family of poets as Professor D. S. Thomson has already suggested (‘The MacMhuirich Bardic Family’, "), _c('em', [_vm._v("TGSI")]), _vm._v(", xliii (1960–3), p. 291) and "), _c('em', [_vm._v("mac an ollaimh")]), _vm._v(" should not therefore be regarded as a surname with "), _c('em', [_vm._v("ollamh")]), _vm._v(" in the sense of physician but is descriptive of Gille-Coluim’s father as a master poet and head of the MacMhuirich family. Indeed, Gille-Coluim describes himself as an "), _c('em', [_vm._v("ollamh")]), _vm._v(" in the sense of poet ("), _c('em', [_vm._v("BDL")]), _vm._v(", p. 72).")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn70",
      "id": "fn70"
    }
  }, [_vm._v("70")]), _vm._v("    See also his careless handling of dates, "), _c('em', [_vm._v("supra")]), _vm._v(", p. 7.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn71",
      "id": "fn71"
    }
  }, [_vm._v("71")]), _vm._v(" "), _c('em', [_vm._v("Infra")]), _vm._v(", p. 21.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn72",
      "id": "fn72"
    }
  }, [_vm._v("72")]), _vm._v("    Add. 15,582, f. 61r.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn73",
      "id": "fn73"
    }
  }, [_vm._v("73")]), _vm._v("    Dunvegan Papers, Box 16, no. 7, 1 Mar.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn74",
      "id": "fn74"
    }
  }, [_vm._v("74")]), _vm._v("    Add 15,582, f. 61r.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn75",
      "id": "fn75"
    }
  }, [_vm._v("75")]), _vm._v(" "), _c('em', [_vm._v("Ibid")]), _vm._v("., f. 69v.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn76",
      "id": "fn76"
    }
  }, [_vm._v("76")]), _vm._v(" "), _c('em', [_vm._v("Infra")]), _vm._v(", p. 21.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn77",
      "id": "fn77"
    }
  }, [_vm._v("77")]), _vm._v("    Walsh, P., "), _c('em', [_vm._v("Gleanings,")]), _vm._v(" p. 142.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn78",
      "id": "fn78"
    }
  }, [_vm._v("78")]), _vm._v(" "), _c('em', [_vm._v("Infra")]), _vm._v(", pp. 98–106.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn79",
      "id": "fn79"
    }
  }, [_vm._v("79")]), _vm._v(" "), _c('em', [_vm._v("RMS")]), _vm._v(", vii (1609–20), no. 109.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn80",
      "id": "fn80"
    }
  }, [_vm._v("80")]), _vm._v(" "), _c('em', [_vm._v("RPC")]), _vm._v(", x (1613–16), pp. xli–lix, 590–1.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn81",
      "id": "fn81"
    }
  }, [_vm._v("81")]), _vm._v("    Smith, "), _c('em', [_vm._v("Islay Bk")]), _vm._v("., p. 382.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn82",
      "id": "fn82"
    }
  }, [_vm._v("82")]), _vm._v("    Giblin, "), _c('em', [_vm._v("Franciscan Mission")]), _vm._v(", p. 40.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn83",
      "id": "fn83"
    }
  }, [_vm._v("83")]), _vm._v("    Smith, "), _c('em', [_vm._v("Islay Bk")]), _vm._v("., p. 382.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn84",
      "id": "fn84"
    }
  }, [_vm._v("84")]), _vm._v("    GRS, 1/27, f. 116a.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn85",
      "id": "fn85"
    }
  }, [_vm._v("85")]), _vm._v(" "), _c('em', [_vm._v("Ibid")]), _vm._v("., fos. 116, 129. That Ballenabe passed from a Beaton to a Campbell is the only point at which tradition agrees with the contemporary record evidence (MacLagan, R. C., ‘The MacBeths of Islay’, "), _c('em', [_vm._v("CMJ")]), _vm._v(", iii (1897–9), pp. 133–5.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn86",
      "id": "fn86"
    }
  }, [_vm._v("86")]), _vm._v("    Cawdor Papers, bundle 655, Islay Rental 1643, p. 9.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn87",
      "id": "fn87"
    }
  }, [_vm._v("87")]), _vm._v("    N.M.A.S., MCR 40, f. 108v.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn88",
      "id": "fn88"
    }
  }, [_vm._v("88")]), _vm._v("    N.M.A.S., MCR 39; Thomson, D. S., ‘The Poetry of Niall MacMhuirich’, "), _c('em', [_vm._v("TGSI")]), _vm._v(", xlvi (1969–70), pp. 283–4.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn89",
      "id": "fn89"
    }
  }, [_vm._v("89")]), _vm._v("    N.M.A.S., MCR 40, f. 89r 7.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn90",
      "id": "fn90"
    }
  }, [_vm._v("90")]), _vm._v("    MacDonald, "), _c('em', [_vm._v("Clan Donald")]), _vm._v(", iii, p. 128.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn91",
      "id": "fn91"
    }
  }, [_vm._v("91")]), _vm._v("    f. 108r.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn92",
      "id": "fn92"
    }
  }, [_vm._v("92")]), _vm._v("    MacDonald, "), _c('em', [_vm._v("History")]), _vm._v(", pp. 2, 60; Steer and Bannerman, "), _c('em', [_vm._v("Monumental Sculpture")]), _vm._v(", p. 126, n.16.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn93",
      "id": "fn93"
    }
  }, [_vm._v("93")]), _vm._v("    MacDonald, "), _c('em', [_vm._v("History")]), _vm._v(", pp. 48, 59, 63 "), _c('em', [_vm._v("etc.")])]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn94",
      "id": "fn94"
    }
  }, [_vm._v("94")]), _vm._v("    Adv. 73. 1. 12 (MS CVII).")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn95",
      "id": "fn95"
    }
  }, [_vm._v("95")]), _vm._v("    MacDonald, "), _c('em', [_vm._v("History")]), _vm._v(", p. 45.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn96",
      "id": "fn96"
    }
  }, [_vm._v("96")]), _vm._v(" "), _c('em', [_vm._v("Ibid")]), _vm._v("., p. 20.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn97",
      "id": "fn97"
    }
  }, [_vm._v("97")]), _vm._v(" "), _c('em', [_vm._v("Ibid")]), _vm._v("., p. 20.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn98",
      "id": "fn98"
    }
  }, [_vm._v("98")]), _vm._v(" "), _c('em', [_vm._v("Supra")]), _vm._v(", pp. 8–11. The Uí Néill are here represented by the later surname O’Néill.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn99",
      "id": "fn99"
    }
  }, [_vm._v("99")]), _vm._v("    Laing MS III 21, f. 103r, v.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn100",
      "id": "fn100"
    }
  }, [_vm._v("100")]), _vm._v(" "), _c('em', [_vm._v("Ibid")]), _vm._v("., fos. 94v, 95r, 110v; Add. 15,582, f. 69v.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn101",
      "id": "fn101"
    }
  }, [_vm._v("101")]), _vm._v("  There are two sets of three cushions or lozenges and three otters’ heads erased, not boars’ heads as suggested elsewhere ("), _c('em', [_vm._v("Inventory of Argyll")]), _vm._v(", iv, pp. 241–2; Stevenson, J. H., and Wood, M., "), _c('em', [_vm._v("Scottish Heraldic Seals")]), _vm._v(", ii, 1940, pp. 242–4). See also the Balfour family, predecessors of the Beatons, in Balfour ("), _c('em', [_vm._v("ibid.")]), _vm._v(", pp. 236–7; "), _c('em', [_vm._v("Gen. Coll")]), _vm._v("., i, pp. 3–4).")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn102",
      "id": "fn102"
    }
  }, [_vm._v("102")]), _vm._v("  MacDonald, "), _c('em', [_vm._v("History")]), _vm._v(", p. 20.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn103",
      "id": "fn103"
    }
  }, [_vm._v("103")]), _vm._v("  Gregory, D., "), _c('em', [_vm._v("History of the Western Highlands and Isles of Scotland")]), _vm._v(", 1836, p. 10, n. 1; Adv. 73. 1. 12 (MS CVII), p. i.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn104",
      "id": "fn104"
    }
  }, [_vm._v("104")]), _vm._v("  Martin, "), _c('em', [_vm._v("Western Islands")]), _vm._v(", p. 250.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn105",
      "id": "fn105"
    }
  }, [_vm._v("105")]), _vm._v(" "), _c('em', [_vm._v("ClanranaldBk")]), _vm._v("., p. 162; MacDonald, "), _c('em', [_vm._v("History")]), _vm._v(", pp. 48–50. Martin Martin followed the MacMhuirich version of events, although the "), _c('em', [_vm._v("History")]), _vm._v(" is more detailed.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn106",
      "id": "fn106"
    }
  }, [_vm._v("106")]), _vm._v("  ‘Geneology of the MacRas’, "), _c('em', [_vm._v("HP")]), _vm._v(", i, p. 198. This tract seems to have been written by Mr John MacRae, minister of Dingwall (1674–1704) ("), _c('em', [_vm._v("ibid")]), _vm._v("., p. 196).")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn107",
      "id": "fn107"
    }
  }, [_vm._v("107")]), _vm._v("  Add. 15,582, ins., b. c.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn108",
      "id": "fn108"
    }
  }, [_vm._v("108")]), _vm._v(" "), _c('em', [_vm._v("Ibid")]), _vm._v("., f. 69v.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn109",
      "id": "fn109"
    }
  }, [_vm._v("109")]), _vm._v("  Adv. 72. 1. 29.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn110",
      "id": "fn110"
    }
  }, [_vm._v("110")]), _vm._v("  f. 13v.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn111",
      "id": "fn111"
    }
  }, [_vm._v("111")]), _vm._v(" "), _c('em', [_vm._v("Infra")]), _vm._v(", pp. 23, 41.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn112",
      "id": "fn112"
    }
  }, [_vm._v("112")]), _vm._v("  f. 3va.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn113",
      "id": "fn113"
    }
  }, [_vm._v("113")]), _vm._v(" "), _c('em', [_vm._v("Supra")]), _vm._v(", p. 17.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn114",
      "id": "fn114"
    }
  }, [_vm._v("114")]), _vm._v("  Mag Uidhir, S., "), _c('em', [_vm._v("Pàdraig Mac a Liondain: Dánta")]), _vm._v(", 1977, pp. 1–4, 60–2.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn115",
      "id": "fn115"
    }
  }, [_vm._v("115")]), _vm._v("  Clanranald Papers, GD 201/3/14. Unless otherwise stated sums of money are in Scottish currency.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn116",
      "id": "fn116"
    }
  }, [_vm._v("116")]), _vm._v(" "), _c('em', [_vm._v("Ibid")]), _vm._v("., GD 201/3/10.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn117",
      "id": "fn117"
    }
  }, [_vm._v("117")]), _vm._v(" "), _c('em', [_vm._v("Ibid")]), _vm._v("., GD 201/1/348.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn118",
      "id": "fn118"
    }
  }, [_vm._v("118")]), _vm._v(" "), _c('em', [_vm._v("Ibid")]), _vm._v("., GD 201/3/6. Only the signature of Mr Archibald MacQueen is now visible.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn119",
      "id": "fn119"
    }
  }, [_vm._v("119")]), _vm._v(" "), _c('em', [_vm._v("Ibid")]), _vm._v("., GD 201/3/12.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn120",
      "id": "fn120"
    }
  }, [_vm._v("120")]), _vm._v(" "), _c('em', [_vm._v("Ibid")]), _vm._v("., GD 201/3/13.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn121",
      "id": "fn121"
    }
  }, [_vm._v("121")]), _vm._v("  N.M.A.S., MCR39, p. 192.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn122",
      "id": "fn122"
    }
  }, [_vm._v("122")]), _vm._v(" "), _c('em', [_vm._v("Clanranald Bk")]), _vm._v("., p. 207.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn123",
      "id": "fn123"
    }
  }, [_vm._v("123")]), _vm._v("  N.M.A.S., MCR 40, f. 82v.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn124",
      "id": "fn124"
    }
  }, [_vm._v("124")]), _vm._v("  f. 1v.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn125",
      "id": "fn125"
    }
  }, [_vm._v("125")]), _vm._v(" "), _c('em', [_vm._v("Glas. Mun")]), _vm._v("., iii, pp. 35, 112.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn126",
      "id": "fn126"
    }
  }, [_vm._v("126")]), _vm._v("  Clanranald Papers, GD 201/3/12.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn127",
      "id": "fn127"
    }
  }, [_vm._v("127")]), _vm._v("  Adv. 72, 1. 29, f. 7r.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn128",
      "id": "fn128"
    }
  }, [_vm._v("128")]), _vm._v(" "), _c('em', [_vm._v("Supra")]), _vm._v(", p. 20 and "), _c('em', [_vm._v("infra")]), _vm._v(", p. 41.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn129",
      "id": "fn129"
    }
  }, [_vm._v("129")]), _vm._v("  Adv. 84. 1. 16 (cover for Adv. 72. 1. 27), f. 1r.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn130",
      "id": "fn130"
    }
  }, [_vm._v("130")]), _vm._v("  Adv. 84. 1. 18 (cover for Adv. 72. 1. 14), f. 5r.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn131",
      "id": "fn131"
    }
  }, [_vm._v("131")]), _vm._v("  See copy of transcript notes with Adv. 84. 1. 17 by Mgr. David McRoberts, dated 25 February 1969, and Bannerman, J., ‘The MacLachlans of Kilbride and their Manuscripts’, "), _c('em', [_vm._v("SS")]), _vm._v(", xxi (1977), p. 30, n.18.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn132",
      "id": "fn132"
    }
  }, [_vm._v("132")]), _vm._v("  Morrison, D., "), _c('em', [_vm._v("Traditions of the Western Isles")]), _vm._v(", ed. MacDonald, N., 1975, pp. 348–52.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn133",
      "id": "fn133"
    }
  }, [_vm._v("133")]), _vm._v("  Lord MacDonald MSS., GD 221/7.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn134",
      "id": "fn134"
    }
  }, [_vm._v("134")]), _vm._v(" "), _c('em', [_vm._v("Ibid")]), _vm._v("., GD 221/7/75.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn135",
      "id": "fn135"
    }
  }, [_vm._v("135")]), _vm._v(" "), _c('em', [_vm._v("Ibid")]), _vm._v("., GD 221/66/23.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn136",
      "id": "fn136"
    }
  }, [_vm._v("136")]), _vm._v("  S.R.O., RH 2/4/312, p. 750.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn137",
      "id": "fn137"
    }
  }, [_vm._v("137")]), _vm._v(" "), _c('em', [_vm._v("Supra")]), _vm._v(", p. 12.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn138",
      "id": "fn138"
    }
  }, [_vm._v("138")]), _vm._v("  Lord MacDonald MSS., GD 221/7/75.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn139",
      "id": "fn139"
    }
  }, [_vm._v("139")]), _vm._v("  MacDonald, "), _c('em', [_vm._v("Clan Donald")]), _vm._v(", iii, p. 128.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn140",
      "id": "fn140"
    }
  }, [_vm._v("140")]), _vm._v("  Lord MacDonald MSS., GD 221/118, pp. 22–3.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn141",
      "id": "fn141"
    }
  }, [_vm._v("141")]), _vm._v("  I am indebted to the late Mr Eric Cregeen for making available to me photocopies of these documents. The originals are in the Inveraray Muniments in a volume designated M9.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn142",
      "id": "fn142"
    }
  }, [_vm._v("142")]), _vm._v("  Confirmed by another and fuller inventory of Pennycross writs in the Saltoun Coll., box 410.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn143",
      "id": "fn143"
    }
  }, [_vm._v("143")]), _vm._v("  MacKinnon, "), _c('em', [_vm._v("Catalogue")]), _vm._v(", p. 286. Mid-nineteenth century tradition maintained that “MacLean of Duart was wounded by a poisoned arrow, and his case thought hopeless: Beaton, to the wonder of the world, established a cure, for which the laird presented him with Pennycross in perpetuity” (Muir, "), _c('em', [_vm._v("Church Architecture")]), _vm._v(", p. 147, n.). But see also MacKechnie, J., "), _c('em', [_vm._v("The Dewar Manuscripts")]), _vm._v(", 1964, pp. 260–3.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn144",
      "id": "fn144"
    }
  }, [_vm._v("144")]), _vm._v("  AT.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn145",
      "id": "fn145"
    }
  }, [_vm._v("145")]), _vm._v(" "), _c('em', [_vm._v("Inventory of Argyll")]), _vm._v(", iii, pp. 159–60.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn146",
      "id": "fn146"
    }
  }, [_vm._v("146")]), _vm._v("  Steer and Bannerman, "), _c('em', [_vm._v("Monumental Sculpture")]), _vm._v(", p. 138.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn147",
      "id": "fn147"
    }
  }, [_vm._v("147")]), _vm._v("  f. 85r.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn148",
      "id": "fn148"
    }
  }, [_vm._v("148")]), _vm._v("  Bannerman, J., and Black, R., ‘A Sixteenth-century Gaelic Letter’, "), _c('em', [_vm._v("SGS")]), _vm._v(", xiii, pt. 1, 1978, pp. 56–65.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn149",
      "id": "fn149"
    }
  }, [_vm._v("149")]), _vm._v("  Martin, "), _c('em', [_vm._v("Western Islands")]), _vm._v(", pp. 283–4.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn150",
      "id": "fn150"
    }
  }, [_vm._v("150")]), _vm._v("  Adv. 72. 1. 33., p. 84.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn151",
      "id": "fn151"
    }
  }, [_vm._v("151")]), _vm._v(" "), _c('em', [_vm._v("Ibid")]), _vm._v("., “is dursan lem nach bfuigim cunntafart do chuir an en focul o d’iomaigh siad”.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn152",
      "id": "fn152"
    }
  }, [_vm._v("152")]), _vm._v("  McLysaght, E., "), _c('em', [_vm._v("Irish Families")]), _vm._v(", 1972, pp. 118–19.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn153",
      "id": "fn153"
    }
  }, [_vm._v("153")]), _vm._v(" "), _c('em', [_vm._v("FM")]), _vm._v(" 1395.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn154",
      "id": "fn154"
    }
  }, [_vm._v("154")]), _vm._v("  Dolley, M., "), _c('em', [_vm._v("Anglo-Norman Ireland")]), _vm._v(", 1972, pp. 84, 150; Byrne, F. J., "), _c('em', [_vm._v("Irish Kings and High-Kings")]), _vm._v(", 1973, pp. 128–9.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn155",
      "id": "fn155"
    }
  }, [_vm._v("155")]), _vm._v(" "), _c('em', [_vm._v("FM")]), _vm._v(". See also "), _c('em', [_vm._v("FM")]), _vm._v(" 1497 and "), _c('em', [_vm._v("Annals of Loch Cé")]), _vm._v(" 1527.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn156",
      "id": "fn156"
    }
  }, [_vm._v("156")]), _vm._v(" "), _c('em', [_vm._v("Annals of Loch Cé")]), _vm._v(". See also "), _c('em', [_vm._v("FM.")])]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn157",
      "id": "fn157"
    }
  }, [_vm._v("157")]), _vm._v("  f. 103r.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn158",
      "id": "fn158"
    }
  }, [_vm._v("158")]), _vm._v("  f. 54v, b21.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn159",
      "id": "fn159"
    }
  }, [_vm._v("159")]), _vm._v("  Add. 15,582, f. 69v, b9, and "), _c('em', [_vm._v("supra")]), _vm._v(", pp. 14, 20.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn160",
      "id": "fn160"
    }
  }, [_vm._v("160")]), _vm._v(" "), _c('em', [_vm._v("Inventory of Argyll")]), _vm._v(", iv, p. 241.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn161",
      "id": "fn161"
    }
  }, [_vm._v("161")]), _vm._v("  Adv. 72. 1. 29, f. 13v. The final figure of the year date is smudged but it looks more like a ‘4’ than anything else.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn162",
      "id": "fn162"
    }
  }, [_vm._v("162")]), _vm._v(" "), _c('em', [_vm._v("Argyll Syn")]), _vm._v("., i, p. 202.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn163",
      "id": "fn163"
    }
  }, [_vm._v("163")]), _vm._v("  Dunvegan Papers., Box 14C, folder: “Debts due by MacLean of Duart”. The medical manuscript, Adv. 18.2.11, was being written at Duart on 26 October 1621 for somebody identified only as "), _c('em', [_vm._v("Eoin")]), _vm._v(". John Beaton was only twenty-seven years old at this point and, considering the length of training normally required to become a qualified physician ("), _c('em', [_vm._v("infra")]), _vm._v(", p. 102), is not likely to have already attained the rank of "), _c('em', [_vm._v("an t-Ollamh Muileach")]), _vm._v(" which would allow him to order the copying of a manuscript in his own school. It is more probable that Eoin was a visiting physician who commissioned this manuscript from scribes who included James Beaton of Dervaig likely to be the contemporary "), _c('em', [_vm._v("ollamh Muileach")]), _vm._v(" ("), _c('em', [_vm._v("infra")]), _vm._v(", pp. 49–51).")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn164",
      "id": "fn164"
    }
  }, [_vm._v("164")]), _vm._v("  Adv. 72. 1. 2., f. 124r; "), _c('em', [_vm._v("supra")]), _vm._v(", p. 1.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn165",
      "id": "fn165"
    }
  }, [_vm._v("165")]), _vm._v(" "), _c('em', [_vm._v("Infra")]), _vm._v(", pp. 35–9.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn166",
      "id": "fn166"
    }
  }, [_vm._v("166")]), _vm._v("  Beaton, J. H., and Beaton, G. H., "), _c('em', [_vm._v("William Beaton, 1774-1834, Cathrine McFee 1814, of Mull, Scotland, and their descendants in North America")]), _vm._v(", 1969, p. 9. William’s grandfather, also William, is omitted in all but one of the various versions of the pedigree preserved in Canada but it is likely to be the correct one, if only because his existence fits the known dates satisfactorily.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn167",
      "id": "fn167"
    }
  }, [_vm._v("167")]), _vm._v(" "), _c('em', [_vm._v("Argyll Syn")]), _vm._v("., ii. p. 130.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn168",
      "id": "fn168"
    }
  }, [_vm._v("168")]), _vm._v("  Adv. 72. 1. 2, fos. 50, 65v. See also Black, Catalogue.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn169",
      "id": "fn169"
    }
  }, [_vm._v("169")]), _vm._v(" "), _c('em', [_vm._v("Infra")]), _vm._v(", p. 144.")]), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn170",
      "id": "fn170"
    }
  }, [_vm._v("170")]), _vm._v(" "), _c('em', [_vm._v("Infra")]), _vm._v(", pp. 51, 66.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn171",
      "id": "fn171"
    }
  }, [_vm._v("171")]), _vm._v(" "), _c('em', [_vm._v("HP")]), _vm._v(", i, p. 299.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn172",
      "id": "fn172"
    }
  }, [_vm._v("172")]), _vm._v("  ins. f. c.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn173",
      "id": "fn173"
    }
  }, [_vm._v("173")]), _vm._v(" "), _c('em', [_vm._v("Supra")]), _vm._v(", p. 20.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn174",
      "id": "fn174"
    }
  }, [_vm._v("174")]), _vm._v("  f. 85r.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn175",
      "id": "fn175"
    }
  }, [_vm._v("175")]), _vm._v("  MacKenzie, "), _c('em', [_vm._v("Sàr-Obair")]), _vm._v(", pp. 389–90.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn176",
      "id": "fn176"
    }
  }, [_vm._v("176")]), _vm._v(" "), _c('em', [_vm._v("Infra")]), _vm._v(", p. 35.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn177",
      "id": "fn177"
    }
  }, [_vm._v("177")]), _vm._v(" "), _c('em', [_vm._v("Encyclopaedia Britannica")]), _vm._v(", 15th edition, x, p. 1153.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn178",
      "id": "fn178"
    }
  }, [_vm._v("178")]), _vm._v("  See MacKinnon, D., ‘The Genealogy of the MacBeths or Beatons of Islay and Mull’, p. 150.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn179",
      "id": "fn179"
    }
  }, [_vm._v("179")]), _vm._v("  Adv. 72. 1. 1. (MS I), f. 1r.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn180",
      "id": "fn180"
    }
  }, [_vm._v("180")]), _vm._v("  Martin, "), _c('em', [_vm._v("Western Islands")]), _vm._v(", p. 340.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn181",
      "id": "fn181"
    }
  }, [_vm._v("181")]), _vm._v("  Sinclair, "), _c('em', [_vm._v("Clan Gillean")]), _vm._v(", p. 206.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn182",
      "id": "fn182"
    }
  }, [_vm._v("182")]), _vm._v(" "), _c('em', [_vm._v("Supra")]), _vm._v(", pp. 29–31.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn183",
      "id": "fn183"
    }
  }, [_vm._v("183")]), _vm._v("  Lochbuie Papers, GD 174/133/11.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn184",
      "id": "fn184"
    }
  }, [_vm._v("184")]), _vm._v(" "), _c('em', [_vm._v("Infra")]), _vm._v(", pp. 49–51.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn185",
      "id": "fn185"
    }
  }, [_vm._v("185")]), _vm._v("  Campbell and Thomson, "), _c('em', [_vm._v("Lhuyd")]), _vm._v(", p. 33, and see "), _c('em', [_vm._v("infra")]), _vm._v(", p. 130.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn186",
      "id": "fn186"
    }
  }, [_vm._v("186")]), _vm._v("  Isles Tests, CC 12/3/2, p. 52. The date of John Beaton’s death is left blank in the testament but the inventory consists of a list of moneys owing to his widow as a result of certain obligations on his behalf dating to the months of May, June and July, 1710, “ffour years immediately preceeding the said defunct his decease”.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn187",
      "id": "fn187"
    }
  }, [_vm._v("187")]), _vm._v("  Lochbuie Papers, GD 174/133/5.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn188",
      "id": "fn188"
    }
  }, [_vm._v("188")]), _vm._v("  ‘Genealogie of the Beattons of Peinnacross’.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn189",
      "id": "fn189"
    }
  }, [_vm._v("189")]), _vm._v("  Lochbuie Papers, GD 174/70; Saltoun Coll., Box 398; Timperley, L. R., "), _c('em', [_vm._v("A Directory of Landownership in Scotland c.1770")]), _vm._v(", SRS, New Ser., 5 (1976), p. 37.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn190",
      "id": "fn190"
    }
  }, [_vm._v("190")]), _vm._v("  Saltoun Coll., Box 398.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn191",
      "id": "fn191"
    }
  }, [_vm._v("191")]), _vm._v("  Lochbuie Papers, GD 174/133/5.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn192",
      "id": "fn192"
    }
  }, [_vm._v("192")]), _vm._v("  Later he maintained that Edmund’s death took place in Jamaica “in the year 1758 or 1759” ("), _c('em', [_vm._v("ibid")]), _vm._v("., GD 174/133/11).")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn193",
      "id": "fn193"
    }
  }, [_vm._v("193")]), _vm._v(" "), _c('em', [_vm._v("Ibid")]), _vm._v("., GD 174/133/5.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn194",
      "id": "fn194"
    }
  }, [_vm._v("194")]), _vm._v(" "), _c('em', [_vm._v("Ibid")]), _vm._v("., GD 174/133/1, 2.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn195",
      "id": "fn195"
    }
  }, [_vm._v("195")]), _vm._v(" "), _c('em', [_vm._v("Ibid")]), _vm._v("., GD 174/133/9, 12.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn196",
      "id": "fn196"
    }
  }, [_vm._v("196")]), _vm._v(" "), _c('em', [_vm._v("Ibid")]), _vm._v("., GD 174/133/9.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn197",
      "id": "fn197"
    }
  }, [_vm._v("197")]), _vm._v("  Bristol, N. M., ‘The Beatons’, "), _c('em', [_vm._v("Notes and Queries")]), _vm._v(", No. ix (1979), p. 27. See also MacLaine of Lochbuie Papers, GD 174/148; Sinclair, "), _c('em', [_vm._v("Clan Gillean")]), _vm._v(", pp. 444–5, 448. Alexander MacLean’s son, Archibald, was seized in the lands of Pennycross on 19 April 1788 (GRS, 3/453, f. 39).")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn198",
      "id": "fn198"
    }
  }, [_vm._v("198")]), _vm._v("  Lochbuie Papers, GD 174/70.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn199",
      "id": "fn199"
    }
  }, [_vm._v("199")]), _vm._v("  Campbell and Thomson, "), _c('em', [_vm._v("Lhuyd")]), _vm._v(", p. 33.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn200",
      "id": "fn200"
    }
  }, [_vm._v("200")]), _vm._v("  Muir, "), _c('em', [_vm._v("Church Architecture")]), _vm._v(", p. 147, n.. See also Armstrong, R. A., "), _c('em', [_vm._v("A Gaelic Dictionary")]), _vm._v(", 1825, p. 433.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn201",
      "id": "fn201"
    }
  }, [_vm._v("201")]), _vm._v("  Appendix III.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn202",
      "id": "fn202"
    }
  }, [_vm._v("202")]), _vm._v("  Laing MS III, 21, f. 103r.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn203",
      "id": "fn203"
    }
  }, [_vm._v("203")]), _vm._v(" "), _c('em', [_vm._v("HP")]), _vm._v(", i, p. 299.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn204",
      "id": "fn204"
    }
  }, [_vm._v("204")]), _vm._v("  Campbell and Thomson, "), _c('em', [_vm._v("Lhuyd")]), _vm._v(", p. 33.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn205",
      "id": "fn205"
    }
  }, [_vm._v("205")]), _vm._v(" "), _c('em', [_vm._v("Argyll Syn")]), _vm._v("., i, p. 202.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn206",
      "id": "fn206"
    }
  }, [_vm._v("206")]), _vm._v("  Smout, T. C., "), _c('em', [_vm._v("A History of the Scottish People")]), _vm._v(", 1970, p. 89.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn207",
      "id": "fn207"
    }
  }, [_vm._v("207")]), _vm._v(" "), _c('em', [_vm._v("Glas. Mun")]), _vm._v("., iii, p. 37; Scott, "), _c('em', [_vm._v("Fasti")]), _vm._v(", iv, p. 114.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn208",
      "id": "fn208"
    }
  }, [_vm._v("208")]), _vm._v("  Anderson, J. R., "), _c('em', [_vm._v("The Burgesses and Guild Brethren of Glasgow")]), _vm._v(", SRS, 1925, p. 214.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn209",
      "id": "fn209"
    }
  }, [_vm._v("209")]), _vm._v("  Adv. 72. 1, 3, f. 98r. The date has been read as ‘1671’ (MacKinnon, "), _c('em', [_vm._v("Catalogue")]), _vm._v(", p. 17), but elsewhere in the manuscript John Beaton signed his name on 20 September 1677 (f. 52v). A patch in the vellum seems to have altered an intended figure ‘7’ to look more like ‘1’.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn210",
      "id": "fn210"
    }
  }, [_vm._v("210")]), _vm._v(" "), _c('em', [_vm._v("RPC")]), _vm._v(", 3rd ser., vii (1681–2), pp. 381–2. The other three were Lachlan MacLean of Torloisk, Lachlan MacLean of Brolas and Mr Duncan Beaton, minister of Kilfinichen. Duncan, who died in 1717, was a nephew of Angus (1641), last Beaton doctor of Husabost (Scott, "), _c('em', [_vm._v("Fasti")]), _vm._v(", iv, p. 112; Whyte, "), _c('em', [_vm._v("Bethunes")]), _vm._v(", p. 27).")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn211",
      "id": "fn211"
    }
  }, [_vm._v("211")]), _vm._v(" "), _c('em', [_vm._v("RPC")]), _vm._v(", 3rd ser., viii (1683–4), pp. 93–5.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn212",
      "id": "fn212"
    }
  }, [_vm._v("212")]), _vm._v("  Ó Baoill, "), _c('em', [_vm._v("Eachann Bacach")]), _vm._v(", pp. 311–12; Campbell, "), _c('em', [_vm._v("Highland Rites")]), _vm._v(", pp. 102–3; "), _c('em', [_vm._v("supra")]), _vm._v(", p. 34.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn213",
      "id": "fn213"
    }
  }, [_vm._v("213")]), _vm._v("  Sinclair, "), _c('em', [_vm._v("Clan Gillean")]), _vm._v(", pp. 223–5.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn214",
      "id": "fn214"
    }
  }, [_vm._v("214")]), _vm._v("  Adv. 72. 1. 20, f. 6v. “an dara bhliadhain tar eis dona saxanachuibh 7 don iomlan don proesdanachuibh bhreitine moire 7 na Herin . . . malle ri Uileam Phrions Orans Righ Sémus a chur ar dibra chum na firinche”.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn215",
      "id": "fn215"
    }
  }, [_vm._v("215")]), _vm._v("  Reg. Argyll Syn., CH 2/557/3, p. 771.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn216",
      "id": "fn216"
    }
  }, [_vm._v("216")]), _vm._v("  Scott, "), _c('em', [_vm._v("Fasti")]), _vm._v(", iv, p. 114.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn217",
      "id": "fn217"
    }
  }, [_vm._v("217")]), _vm._v("  Adv. 72. 1. 33 (MS XXXIII), f. 1r.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn218",
      "id": "fn218"
    }
  }, [_vm._v("218")]), _vm._v("  Campbell and Thomson, "), _c('em', [_vm._v("Lhuyd")]), _vm._v(", p. 12; Campbell, "), _c('em', [_vm._v("Highland Rites")]), _vm._v(", p. 101.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn219",
      "id": "fn219"
    }
  }, [_vm._v("219")]), _vm._v("  MS 1363, p. 221.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn220",
      "id": "fn220"
    }
  }, [_vm._v("220")]), _vm._v("  In the circumstances outlined above, the late and apparently unsupported statement that John Beaton was “outed for immoral conduct in 1701” (Scott, "), _c('em', [_vm._v("Fasti")]), _vm._v(", iv, p. 114) hardly needs refuting. See also Campbell and Thomson, "), _c('em', [_vm._v("Lhuyd")]), _vm._v(", p. 22.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn221",
      "id": "fn221"
    }
  }, [_vm._v("221")]), _vm._v("  Isles Tests, CC 12/3/2, pp. 52–3.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn222",
      "id": "fn222"
    }
  }, [_vm._v("222")]), _vm._v("  Adv. 72. 1. 3, f. 98r, but see "), _c('em', [_vm._v("supra")]), _vm._v(", p. 36, n. 209.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn223",
      "id": "fn223"
    }
  }, [_vm._v("223")]), _vm._v("  Adv. 72. 1. 3, f. 52v.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn224",
      "id": "fn224"
    }
  }, [_vm._v("224")]), _vm._v("  Adv. 72. 1. 20, f. 6v.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn225",
      "id": "fn225"
    }
  }, [_vm._v("225")]), _vm._v("  Adv. 72. 1. 33, f. 1r.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn226",
      "id": "fn226"
    }
  }, [_vm._v("226")]), _vm._v("  Campbell and Thomson, "), _c('em', [_vm._v("Lhuyd")]), _vm._v(", p. 37.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn227",
      "id": "fn227"
    }
  }, [_vm._v("227")]), _vm._v("  T.C.D., MS 1349 (H. 4. 8); MS 1363 (H 4. 22), Part XVI, p. 221.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn228",
      "id": "fn228"
    }
  }, [_vm._v("228")]), _vm._v("  Campbell and Thomson, "), _c('em', [_vm._v("Lhuyd")]), _vm._v(", pp. 37–46.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn229",
      "id": "fn229"
    }
  }, [_vm._v("229")]), _vm._v(" "), _c('em', [_vm._v("Ibid")]), _vm._v("., p. 24.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn230",
      "id": "fn230"
    }
  }, [_vm._v("230")]), _vm._v("  fos. 7v, 69v.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn231",
      "id": "fn231"
    }
  }, [_vm._v("231")]), _vm._v("  Gillies, H. C, ‘A Gaelic Medical Manuscript of 1563’, "), _c('em', [_vm._v("CMJ")]), _vm._v(", v (1902–04), p. 39.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn232",
      "id": "fn232"
    }
  }, [_vm._v("232")]), _vm._v(" "), _c('em', [_vm._v("Supra")]), _vm._v(", p. 12.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn233",
      "id": "fn233"
    }
  }, [_vm._v("233")]), _vm._v("  Clanranald Papers, GD 201/1/350/138.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn234",
      "id": "fn234"
    }
  }, [_vm._v("234")]), _vm._v("  MacDonald, "), _c('em', [_vm._v("Clan Donald")]), _vm._v(", iii, p. 232.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn235",
      "id": "fn235"
    }
  }, [_vm._v("235")]), _vm._v(" "), _c('em', [_vm._v("Argyll Syn")]), _vm._v("., i, pp. 33, 38, 173–4; ii, pp. 121–2. See also MacKinnon, D., ‘The MacPhersons of Skye’, "), _c('em', [_vm._v("The Scottish Genealogist")]), _vm._v(", i (1954), nos. 2–3, p. 27.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn236",
      "id": "fn236"
    }
  }, [_vm._v("236")]), _vm._v("  Clanranald Papers, GD 201/3/6.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn237",
      "id": "fn237"
    }
  }, [_vm._v("237")]), _vm._v("  Adv. 72. 1. 29, f. 13v.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn238",
      "id": "fn238"
    }
  }, [_vm._v("238")]), _vm._v(" "), _c('em', [_vm._v("Supra")]), _vm._v(", pp. 20, 23.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn239",
      "id": "fn239"
    }
  }, [_vm._v("239")]), _vm._v("  Clanranald Papers, GD 201/1/142.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn240",
      "id": "fn240"
    }
  }, [_vm._v("240")]), _vm._v(" "), _c('em', [_vm._v("Ibid")]), _vm._v("., GD 201/1/143.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn241",
      "id": "fn241"
    }
  }, [_vm._v("241")]), _vm._v("  GRS 3/49, f. 158.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn242",
      "id": "fn242"
    }
  }, [_vm._v("242")]), _vm._v(" "), _c('em', [_vm._v("Ibid")]), _vm._v("., f. 164.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn243",
      "id": "fn243"
    }
  }, [_vm._v("243")]), _vm._v("  Clanranald Papers, GD 201/1/169.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn244",
      "id": "fn244"
    }
  }, [_vm._v("244")]), _vm._v("  Martin, "), _c('em', [_vm._v("Western Islands")]), _vm._v(", p. 155.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn245",
      "id": "fn245"
    }
  }, [_vm._v("245")]), _vm._v("  Dunvegan Papers, Box 24.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn246",
      "id": "fn246"
    }
  }, [_vm._v("246")]), _vm._v("  GRS 3/49, f. 158.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn247",
      "id": "fn247"
    }
  }, [_vm._v("247")]), _vm._v("  GRS, 3/47, f. 242; Dunvegan Papers, Box 16, no. 153.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn248",
      "id": "fn248"
    }
  }, [_vm._v("248")]), _vm._v("  Clanranald Papers, GD 201/1/143A.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn249",
      "id": "fn249"
    }
  }, [_vm._v("249")]), _vm._v("  See below.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn250",
      "id": "fn250"
    }
  }, [_vm._v("250")]), _vm._v("  Clanranald Papers, GD 201/1/146–7; MacDonald, "), _c('em', [_vm._v("Clan Donald")]), _vm._v(", iii, p. 233.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn251",
      "id": "fn251"
    }
  }, [_vm._v("251")]), _vm._v("  PRS (Inverness), 38/4, f. 51.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn252",
      "id": "fn252"
    }
  }, [_vm._v("252")]), _vm._v("  Dunvegan Papers, Box 24.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn253",
      "id": "fn253"
    }
  }, [_vm._v("253")]), _vm._v(" "), _c('em', [_vm._v("Infra")]), _vm._v(", pp. 71–4.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn254",
      "id": "fn254"
    }
  }, [_vm._v("254")]), _vm._v(" "), _c('em', [_vm._v("Supra")]), _vm._v(", p. 9.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn255",
      "id": "fn255"
    }
  }, [_vm._v("255")]), _vm._v("  Whyte, "), _c('em', [_vm._v("Bethunes")]), _vm._v(", pp. 9, 36.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn256",
      "id": "fn256"
    }
  }, [_vm._v("256")]), _vm._v("  Adv. 72. 1. 4, f. 100r.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn257",
      "id": "fn257"
    }
  }, [_vm._v("257")]), _vm._v(" "), _c('em', [_vm._v("Ibid")]), _vm._v("., f. 25.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn258",
      "id": "fn258"
    }
  }, [_vm._v("258")]), _vm._v(" "), _c('em', [_vm._v("Ibid")]), _vm._v("., f. 23r; McRoberts, D., ‘Two Hebridean Liturgical Items’, "), _c('em', [_vm._v("The Innes Review")]), _vm._v(", xix (1968), pt. 2, p. 171.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn259",
      "id": "fn259"
    }
  }, [_vm._v("259")]), _vm._v("  Walsh, "), _c('em', [_vm._v("Irish Men")]), _vm._v(", pp. 206–7; de Brún, P., "), _c('em', [_vm._v("Catalogue of Irish Manuscripts in King’s Inns Library, Dublin")]), _vm._v(", 1972, pp. 36–40.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn260",
      "id": "fn260"
    }
  }, [_vm._v("260")]), _vm._v(" "), _c('em', [_vm._v("ER")]), _vm._v(", xvii (1537–42), pp. 613, 636.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn261",
      "id": "fn261"
    }
  }, [_vm._v("261")]), _vm._v("  ii, pt. 1.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn262",
      "id": "fn262"
    }
  }, [_vm._v("262")]), _vm._v(" "), _c('em', [_vm._v("ER")]), _vm._v(", xvii (1537–42), pp. 620, 640.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn263",
      "id": "fn263"
    }
  }, [_vm._v("263")]), _vm._v(" "), _c('em', [_vm._v("Ibid")]), _vm._v("., pp. 549, 638. His surname is here written "), _c('em', [_vm._v("McMorquhar")]), _vm._v(" but John "), _c('em', [_vm._v("Óg McMurquhie")]), _vm._v(", “leiche in Ilay”, named thus in a bond dated 24 January 1615, signed it “Johne McMurchie, Doctour off Medicine” ("), _c('em', [_vm._v("Cawdor Bk")]), _vm._v("., p. 234). This is almost certainly another hereditary medical family who, on record again in Islay in the nineteenth century and using the most modern form of their Scoticised surname, "), _c('em', [_vm._v("Currie")]), _vm._v(", were still producing physicians (Ramsay, L., "), _c('em', [_vm._v("The Stent Book of Islay")]), _vm._v(", 1890, pp. 233, 269 etc.; Thomson, D. S., ‘The MacMhuirich Bardic Family’, p. 289).")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn264",
      "id": "fn264"
    }
  }, [_vm._v("264")]), _vm._v(" "), _c('em', [_vm._v("Supra")]), _vm._v(", p. 12.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn265",
      "id": "fn265"
    }
  }, [_vm._v("265")]), _vm._v(" "), _c('em', [_vm._v("RMS")]), _vm._v(", iii (1513–46), no. 3085. Kilelane is written "), _c('em', [_vm._v("Killenane")]), _vm._v(" here but see Watson ("), _c('em', [_vm._v("Celtic Placenames")]), _vm._v(", p. 518) for another example of confusion between these forms.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn266",
      "id": "fn266"
    }
  }, [_vm._v("266")]), _vm._v("  Giblin, "), _c('em', [_vm._v("Franciscan Mission")]), _vm._v(", p. 44.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn267",
      "id": "fn267"
    }
  }, [_vm._v("267")]), _vm._v("  Woulfe, "), _c('em', [_vm._v("Sloinnte")]), _vm._v(", p. 182.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn268",
      "id": "fn268"
    }
  }, [_vm._v("268")]), _vm._v("  Ryl. Irish MS. 35, f. 67v. The surname, which is difficult to decipher, could be read "), _c('em', [_vm._v("McKaey")]), _vm._v(" at first glance and therefore be a form of "), _c('em', [_vm._v("MacAoidh")]), _vm._v(" or "), _c('em', [_vm._v("MacKay")]), _vm._v(", frequently recorded in Islay. However, the ornate capital letter is similar to the capital ‘B’ in the signature of Malcolm Beaton of Pennycross (1582–1603) in MS II (Adv. 72. 1. 2, f. 65v), while "), _c('em', [_vm._v("Eamon")]), _vm._v(" or "), _c('em', [_vm._v("Edmond")]), _vm._v(" is not on record among the Islay MacKays.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn269",
      "id": "fn269"
    }
  }, [_vm._v("269")]), _vm._v(" "), _c('em', [_vm._v("Supra")]), _vm._v(", pp. 2–3.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn270",
      "id": "fn270"
    }
  }, [_vm._v("270")]), _vm._v("  f. 67r. “edar an learga 7 an ogha”.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn271",
      "id": "fn271"
    }
  }, [_vm._v("271")]), _vm._v(" "), _c('em', [_vm._v("Geog. Coll")]), _vm._v("., ii, p. 188.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn272",
      "id": "fn272"
    }
  }, [_vm._v("272")]), _vm._v(" "), _c('em', [_vm._v("ER")]), _vm._v(", xvii (1537–42), pp. 611–13, 615–20, 633–41.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn273",
      "id": "fn273"
    }
  }, [_vm._v("273")]), _vm._v("  f. 60v.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn274",
      "id": "fn274"
    }
  }, [_vm._v("274")]), _vm._v(" "), _c('em', [_vm._v("ER")]), _vm._v(", xix (1557–67), pp. 330–55; "), _c('em', [_vm._v("RSS")]), _vm._v(", v (1556–67), no. 2546.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn275",
      "id": "fn275"
    }
  }, [_vm._v("275")]), _vm._v(" "), _c('em', [_vm._v("RSS")]), _vm._v(", v (1556–67), no. 1683.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn276",
      "id": "fn276"
    }
  }, [_vm._v("276")]), _vm._v(" "), _c('em', [_vm._v("ER")]), _vm._v(", xx (1568–79), pp. 378–81.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn277",
      "id": "fn277"
    }
  }, [_vm._v("277")]), _vm._v("  Cawdor Papers, bundle 655, Islay rental 1643, p. 1.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn278",
      "id": "fn278"
    }
  }, [_vm._v("278")]), _vm._v("  Black, "), _c('em', [_vm._v("Surnames")]), _vm._v(", p. 465.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn279",
      "id": "fn279"
    }
  }, [_vm._v("279")]), _vm._v("  Cawdor Papers, bundle 655, Islay rental 1643, pp. 4, 8.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn280",
      "id": "fn280"
    }
  }, [_vm._v("280")]), _vm._v("  Smith, "), _c('em', [_vm._v("Islay Bk")]), _vm._v("., pp. 545, 552.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn281",
      "id": "fn281"
    }
  }, [_vm._v("281")]), _vm._v("  Black, "), _c('em', [_vm._v("Surnames")]), _vm._v(", pp. 23, 453.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn282",
      "id": "fn282"
    }
  }, [_vm._v("282")]), _vm._v("  The hitherto accepted derivation of "), _c('em', [_vm._v("MacGonigle")]), _vm._v(" from "), _c('em', [_vm._v("MacCongail")]), _vm._v(" is not satisfactory (Woulfe, "), _c('em', [_vm._v("Sloinnte")]), _vm._v(", pp. 121, 339; MacLysaght, E., "), _c('em', [_vm._v("More Irish Families")]), _vm._v(", 1960, p. 124).")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn283",
      "id": "fn283"
    }
  }, [_vm._v("283")]), _vm._v("  Black, R., ‘Colla Ciotach’, "), _c('em', [_vm._v("TGSI")]), _vm._v(", xlviii (1972–4), pp. 201–43.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn284",
      "id": "fn284"
    }
  }, [_vm._v("284")]), _vm._v("  Smith, "), _c('em', [_vm._v("Islay Bk")]), _vm._v("., p. 503.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn285",
      "id": "fn285"
    }
  }, [_vm._v("285")]), _vm._v(" "), _c('em', [_vm._v("Supra")]), _vm._v(", p. 33.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn286",
      "id": "fn286"
    }
  }, [_vm._v("286")]), _vm._v("  Fraser, "), _c('em', [_vm._v("Wardlaw MS")]), _vm._v("., pp. 145–6.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn287",
      "id": "fn287"
    }
  }, [_vm._v("287")]), _vm._v(" "), _c('em', [_vm._v("Supra")]), _vm._v(", p. 26.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn288",
      "id": "fn288"
    }
  }, [_vm._v("288")]), _vm._v("  Steer and Bannerman, "), _c('em', [_vm._v("Monumental Sculpture")]), _vm._v(", p. 115.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn289",
      "id": "fn289"
    }
  }, [_vm._v("289")]), _vm._v("  Adv. 72. 1. 3, f. 98r.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn290",
      "id": "fn290"
    }
  }, [_vm._v("290")]), _vm._v("  Adv. 72. 1. 29, f. 2; Adv. 72. 1. 33, section a, f. 1r.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn291",
      "id": "fn291"
    }
  }, [_vm._v("291")]), _vm._v("  Adv. 72. 1. 29, fos. 6v, 13v.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn292",
      "id": "fn292"
    }
  }, [_vm._v("292")]), _vm._v("  fos. 13–33.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn293",
      "id": "fn293"
    }
  }, [_vm._v("293")]), _vm._v(" "), _c('em', [_vm._v("Supra")]), _vm._v(", p. 26–7.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn294",
      "id": "fn294"
    }
  }, [_vm._v("294")]), _vm._v(" "), _c('em', [_vm._v("Supra")]), _vm._v(", pp. 26–32.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn295",
      "id": "fn295"
    }
  }, [_vm._v("295")]), _vm._v("  Adv. 72. 1. 29, f. 2r.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn296",
      "id": "fn296"
    }
  }, [_vm._v("296")]), _vm._v("  Bristol, N. M., ‘The O’Muirgheasáin Bardic Family’, "), _c('em', [_vm._v("Notes and Queries")]), _vm._v(", vi (1978), pp. 3–7; Matheson, W., "), _c('em', [_vm._v("Notes and Queries")]), _vm._v(", vii (1978), pp. 24–5; Black, R., ‘Poems by Maol Domhnaigh Ó Muirgheasáin (I)’, "), _c('em', [_vm._v("SGS")]), _vm._v(", xii (1976), p. 195.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn297",
      "id": "fn297"
    }
  }, [_vm._v("297")]), _vm._v("  MacDonald, J., ‘An Elegy for Ruaidhrí Mór’, "), _c('em', [_vm._v("SGS")]), _vm._v(", viii (1955–8), pp. 27–52.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn298",
      "id": "fn298"
    }
  }, [_vm._v("298")]), _vm._v("  Adv. 72. 1. 29, f. 2v.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn299",
      "id": "fn299"
    }
  }, [_vm._v("299")]), _vm._v("  Cotton, H., "), _c('em', [_vm._v("Fasti Ecclesiae Hiberniae")]), _vm._v(", iii (1849), pp. 316–17. Just too late was the only other bishop of Derry to bear that forename in the sixteenth and seventeenth centuries, namely, John Bramhall, bishop from 1634 until he was impeached and imprisoned by the Irish House of Commons in 1641 ("), _c('em', [_vm._v("Ibid")]), _vm._v("., p. 317; Moody, T. W., and Simms, J. G., "), _c('em', [_vm._v("The Bishopric of Derry and the Irish Society of London")]), _vm._v(", i (1968), pp. 6–7).")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn300",
      "id": "fn300"
    }
  }, [_vm._v("300")]), _vm._v("  Hogan, E., "), _c('em', [_vm._v("Onomasticon Goedelicum")]), _vm._v(", 1910, p. 35.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn301",
      "id": "fn301"
    }
  }, [_vm._v("301")]), _vm._v(" "), _c('em', [_vm._v("Infra")]), _vm._v(", p. 150.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn302",
      "id": "fn302"
    }
  }, [_vm._v("302")]), _vm._v("  Thomson, D. S., ‘The Poetry of Niall MacMhuirich’, "), _c('em', [_vm._v("TGSI")]), _vm._v(", xlvi (1969–70), p. 283.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn303",
      "id": "fn303"
    }
  }, [_vm._v("303")]), _vm._v("  MacKenzie, H., "), _c('em', [_vm._v("Report of the Committee of the Highland Society of Scotland")]), _vm._v(", 1805, Appendix, pp. 275–7.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn304",
      "id": "fn304"
    }
  }, [_vm._v("304")]), _vm._v("  Thomson, D. S., ‘Niall Mór MacMhuirich’, "), _c('em', [_vm._v("TGSI")]), _vm._v(", xlix (1974–6), pp. 9–11.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn305",
      "id": "fn305"
    }
  }, [_vm._v("305")]), _vm._v("  Adv. 72. 1. 3, f. 98r, “Ailian Stiuar/Ailian mac Dhonnchaidh oig rom sgriobh so a leabar semuis mhic ’n ollaimh”.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn306",
      "id": "fn306"
    }
  }, [_vm._v("306")]), _vm._v("  f. 83r.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn307",
      "id": "fn307"
    }
  }, [_vm._v("307")]), _vm._v(" "), _c('em', [_vm._v("Supra")]), _vm._v(", pp. 26–7.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn308",
      "id": "fn308"
    }
  }, [_vm._v("308")]), _vm._v("  Stewart, J. H. J. and D., "), _c('em', [_vm._v("The Stewarts of Appin")]), _vm._v(", 1880, pp. 111–16.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn309",
      "id": "fn309"
    }
  }, [_vm._v("309")]), _vm._v(" "), _c('em', [_vm._v("Supra")]), _vm._v(", pp. 29–30.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn310",
      "id": "fn310"
    }
  }, [_vm._v("310")]), _vm._v("  Church Recs., CH 2/493/1.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn311",
      "id": "fn311"
    }
  }, [_vm._v("311")]), _vm._v(" "), _c('em', [_vm._v("Argyll Syn")]), _vm._v("., ii, pp. 127, 136, 147.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn312",
      "id": "fn312"
    }
  }, [_vm._v("312")]), _vm._v("  Saltoun Coll., Box 112.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn313",
      "id": "fn313"
    }
  }, [_vm._v("313")]), _vm._v("  Muir, "), _c('em', [_vm._v("Church Architecture")]), _vm._v(", pp. 146–7 and n.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn314",
      "id": "fn314"
    }
  }, [_vm._v("314")]), _vm._v(" "), _c('em', [_vm._v("Inventory of Argyll")]), _vm._v(", iii, p. 177; MacKenzie, "), _c('em', [_vm._v("Sàr-Obair")]), _vm._v(", p. 390.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn315",
      "id": "fn315"
    }
  }, [_vm._v("315")]), _vm._v(" "), _c('em', [_vm._v("Supra")]), _vm._v(", pp. 26, 34.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn316",
      "id": "fn316"
    }
  }, [_vm._v("316")]), _vm._v("  MacKenzie, "), _c('em', [_vm._v("Sàr-Obair")]), _vm._v(", pp. 389–90. I am indebted to Mr William Matheson for pointing this out to me.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn317",
      "id": "fn317"
    }
  }, [_vm._v("317")]), _vm._v("  Nicolson, A., ‘The McBeths, Hereditary Physicians of the Highlands’, "), _c('em', [_vm._v("TGSG")]), _vm._v(", v (1958), p. 101.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn318",
      "id": "fn318"
    }
  }, [_vm._v("318")]), _vm._v(" "), _c('em', [_vm._v("Supra")]), _vm._v(", p. 49.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn319",
      "id": "fn319"
    }
  }, [_vm._v("319")]), _vm._v("  B. L. Cotton MS Titus B. xi (pt. 2) f. 179. I am indebted to Mr Kenneth Nicholls for providing me with this reference.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn320",
      "id": "fn320"
    }
  }, [_vm._v("320")]), _vm._v(" "), _c('em', [_vm._v("Fiants, Ire. Eliz")]), _vm._v("., nos. 1571, 1587, 2510, 3287, 6485, 6529, 6764.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn321",
      "id": "fn321"
    }
  }, [_vm._v("321")]), _vm._v("  Ó Cuív, B., ‘The Irish language in the early modern period’, "), _c('em', [_vm._v("A New History of Ireland")]), _vm._v(", ed. Moody, T. W., Martin, F. X., and Byrne, F. J., iii (1976), p. 519.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn322",
      "id": "fn322"
    }
  }, [_vm._v("322")]), _vm._v(" "), _c('em', [_vm._v("Fiants, Ire. Eliz")]), _vm._v("., no. 5797.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn323",
      "id": "fn323"
    }
  }, [_vm._v("323")]), _vm._v(" "), _c('em', [_vm._v("Ibid")]), _vm._v("., no. 5617.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn324",
      "id": "fn324"
    }
  }, [_vm._v("324")]), _vm._v(" "), _c('em', [_vm._v("Supra")]), _vm._v(", p. 8; "), _c('em', [_vm._v("infra")]), _vm._v(", p. 117.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f81905d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter01.vue
// module id = 78
// module chunks = 0